<template>
  <v-app>
    <!-- <AuthLogin v-show="!isAuth"></AuthLogin> -->
    <v-layout xsm="8" sm="8" md="6" lg="4" v-resize="onResize">
      <!-- style="height: v-bind(leftBarHeight)" -->
      <v-navigation-drawer
        v-model="drawer"
        location="left"
        permanent
        rail
        :rail-width="350"
        style="overflow: auto; height: 78%; position: fixed; top: 100px"
      >
        <v-list-item>
          <p class="text-h6">Search By Keyword</p>
        </v-list-item>
        <v-list-item>
          <v-row v-if="toggleOCRFlag">
            <v-col cols="7">
              <v-input hint="(headlines only)" persistent-hint>
                <label>
                  <input
                    type="radio"
                    name="full text"
                    value="fulltext2"
                    v-model="fullTextOCRModel"
                    @click="fullTextRadio"
                  />
                  <span class="font-weight-bold ml-2">Full Text</span>
                </label>
              </v-input>
            </v-col>
            <v-col cols="5">
              <v-input hint="(all text)" persistent-hint>
                <label>
                  <input
                    type="radio"
                    name="full text"
                    value="ocr2"
                    v-model="fullTextOCRModel"
                    @click="OCRRadio"
                    checked
                  />
                  <span class="font-weight-bold ml-2">OCR</span>
                </label>
              </v-input>
            </v-col>
          </v-row>

          <v-row v-else>
            <v-col cols="12" style="margin-top: 5px">
              <v-text-field
                label="OCR(all text)"
                density="compact"
                variant="outlined"
                v-model="ORandInputModel"
                @update:modelValue="OCRInputFnHandler"
                @keydown.enter.prevent="searchHandler"
                persistent-hint
              >
              </v-text-field>
            </v-col>
            <v-col cols="3">
              <label>
                <input
                  type="radio"
                  name="ANDOR"
                  value="AND"
                  v-model="ORandModel"
                  @click="AndFnHandler"
                  :checked="andOrSelected == 1"
                />
                <span class="font-weight-bold ml-2">AND</span>
              </label>
            </v-col>
            <v-col cols="3">
              <label>
                <input
                  type="radio"
                  name="ANDOR"
                  value="OR"
                  v-model="ORandModel"
                  @click="OrFnHandler"
                  :checked="andOrSelected == 0"
                />
                <span class="font-weight-bold ml-2">OR</span>
              </label>
            </v-col>
            <v-col cols="12">
              <v-text-field
                density="compact"
                label="Full Text(headlines only)"
                variant="outlined"
                v-model="FullInputModel"
                @update:modelValue="FullTextInputFnHandler"
                @keydown.enter.prevent="searchHandler"
                persistent-hint
              >
              </v-text-field>
            </v-col>
          </v-row>
          <VerticalSpacer :space="1"></VerticalSpacer>
          <span
            style="color: #00a4e4; cursor: pointer; margin-top: 20px"
            @click="toggleHandler"
          >
            [OCR/Full Text]
          </span>
          <VerticalSpacer :space="1"></VerticalSpacer>
        </v-list-item>
        <v-list-item>
          <v-textarea
            v-if="toggleOCRFlag"
            rows="1"
            density="compact"
            variant="outlined"
            v-model="ORandInputModel"
            @update:modelValue="fullTextOCRInputFnHandler"
            @keydown.enter.prevent="searchHandler"
          >
          </v-textarea>
          <div style="margin-top: 4px">
            <SelectBox
              :propsData="mediachannel"
              :boxName="`Media Channel`"
              :clearFlag="clearAllFlag"
              :isMultipleFlag="true"
            ></SelectBox>
          </div>

          <!-- <VerticalSpacer :space="1"></VerticalSpacer> -->
          <SelectBox
            :propsData="sectorsData"
            :boxName="`Sectors`"
            :isMultipleFlag="true"
          ></SelectBox>
          <v-row align="center" no-gutters>
            <v-col>
              <v-radio-group inline no-gutters v-model="anyOnlyModel">
                <v-radio
                  hide-details
                  value="1"
                  label="Any"
                  @click="show_checkbox = false"
                ></v-radio>

                <v-radio
                  hide-details
                  value="2"
                  label="Only"
                  @click="show_checkbox = true"
                ></v-radio>
              </v-radio-group>
            </v-col>
            <v-col style="margin-top: -25px; margin-left: -17px">
              <v-checkbox
                hide-details
                label="Exact"
                v-model="exactCheckbox"
                :disabled="!show_checkbox"
              ></v-checkbox>
            </v-col>
          </v-row>
          <VerticalSpacer :space="1"></VerticalSpacer>
          <SelectBox
            :propsData="audience"
            :boxName="`Audience`"
            :isMultipleFlag="true"
          ></SelectBox>

          <VerticalSpacer :space="1"></VerticalSpacer>
          <v-select
            class="font-weight-thin"
            item-title="name"
            v-model="selectedDate"
            :items="dateData"
            density="compact"
            variant="outlined"
            label="Search Date"
            :disabled="searchDateBoxFlag"
            @update:modelValue="searchDateHandler"
          >
            <!-- <v-list-item-content>
                <v-list-item-title>aaaa</v-list-item-title>
              </v-list-item-content> -->
          </v-select>
          <VerticalSpacer :space="1"></VerticalSpacer>
          <v-row>
            <v-col>
              <v-select
                v-model="monthSelectionFrom"
                :items="sortedMonthYearArray"
                item-title="name"
                label="Start Month"
                density="compact"
                :disabled="!monthBoxFlag"
                variant="outlined"
                @update:modelValue="monthDropdownHandler"
              >
              </v-select>
            </v-col>
            <v-col>
              <v-select
                v-model="monthSelectionTo"
                :items="sortedMonthYearArray"
                item-title="name"
                label="End Month"
                density="compact"
                :disabled="!monthBoxFlag"
                variant="outlined"
                @update:modelValue="monthDropdownHandler"
                persistent-hint
              >
              </v-select>
            </v-col>
          </v-row>
          <v-sheet class="text-left pa-2 mb-2" border>
            <p
              class="text-subtitle-2 font-weight-medium mb-2"
              style="color: rgb(151, 150, 150)"
            >
              Approved Date:
            </p>
            <v-row>
              <v-col cols="6">
                <!-- <v-menu
                  v-model="frommenu"
                  v-model:return-value="firstdate"
                  :close-on-content-click="false"
                > -->

                <date-picker
                  v-model="firstdate"
                  :update-on-input="true"
                  mode="date"
                  :max-date="new Date()"
                  :popover="{ visibility: 'focus' }"
                  :masks="masks"
                >
                  <template v-slot:default="{ inputValue, inputEvents }">
                    <input
                      class="datepickerinput"
                      v-on="inputEvents"
                      v-bind:value="inputValue"
                      placeholder="From Date"
                    />
                    <!-- </input> -->
                  </template>
                </date-picker>
                <!-- <v-date-picker
                    v-model="firstdate"
                    @update:modelValue="fromfunc"
                    view-mode="month"
                    color="primary"
                    hide-header
                    max-height="300"
                  >
                  </v-date-picker> -->
                <!-- </v-menu> -->
              </v-col>
              <v-col cols="6">
                <date-picker
                  v-model="seconddate"
                  :update-on-input="true"
                  mode="date"
                  :max-date="new Date()"
                  :popover="{ visibility: 'focus' }"
                  :masks="masks"
                >
                  <template v-slot:default="{ inputValue, inputEvents }">
                    <input
                      class="datepickerinput"
                      v-on="inputEvents"
                      v-bind:value="inputValue"
                      placeholder="To Date"
                    />
                    <!-- </input> -->
                  </template>
                </date-picker>
              </v-col>
              <v-col cols="6"
                ><DropdownList
                  :data="timeIntervals"
                  boxName="Start Time"
                  boxType="time"
              /></v-col>
              <v-col cols="6"
                ><DropdownList
                  :data="timeIntervals"
                  boxName="End Time"
                  boxType="time"
              /></v-col>
            </v-row>
          </v-sheet>
          <!-- <v-menu
              :close-on-content-click="false"
              :max-width="350"
              v-model="menu"
            >
              <template v-slot:activator="{ props }">
                <v-text-field
                  v-model="date"
                  class="font-weight-thin"
                  label="Approved Date"
                  variant="outlined"
                  density="compact"
                  v-bind="props"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="datepick"
                @click:cancel="menu = false"
                @update:modelValue="save_date()"
                @click:save="menu = false"
                min="2023-06-09"
                max="2023-09-09"
                view-mode="month"
                multiple
                color="red"
              >
                <template v-slot:header>
                  <div></div>
                </template>
              </v-date-picker>
            </v-menu> -->

          <v-text-field
            label="Panelist id"
            variant="outlined"
            density="compact"
            v-model="panelistId"
            @keydown.enter.prevent="searchHandler"
          ></v-text-field>

          <v-radio-group
            inline
            hide-details
            v-model="panelistSelectedModel"
            @update:model-value="panelistFnHandler"
          >
            <v-radio
              hide-details
              value="primary"
              name="Primary"
              label="Primary"
            ></v-radio>
            <v-radio
              hide-details
              value="non-primary"
              name="Non"
              label="Non"
            ></v-radio>
            <v-radio hide-details value="All" name="All" label="All"></v-radio>
          </v-radio-group>

          <VerticalSpacer :space="1"></VerticalSpacer>
          <v-radio-group inline v-model="countrySelectedModel">
            <v-radio name="All" value="All" label="All"></v-radio>

            <v-radio value="CA" name="Canada" label="Canada"></v-radio>
            <v-radio value="US" name="Usa" label="Usa"></v-radio>
          </v-radio-group>

          <!-- company lookup -->
          <v-row>
            <v-col cols="12" v-click-outside="clickedOut">
              <div v-for="c in choosenCompanies" v-bind:key="c.id">
                <v-chip
                  class="mr-1 mt-1"
                  closable
                  @click:close="removeCompany(c)"
                  >{{ c.name }}</v-chip
                >
                <!-- <v-icon
                      color="red-darken-2 pr-2"
                      :class="{ 'cursor-pointer': hover }"
                      left
                      @click.prevent="removeCompany(c)"
                    >
                      mdi-minus-circle
                    </v-icon> -->
              </div>
              <v-text-field
                class="font-weight-small"
                variant="outlined"
                density="compact"
                :label="companyLabel"
                v-model="company"
                @input="handleInput"
                persistent-hint
                style="margin-top: 9px"
              >
              </v-text-field>
              <div style="margin-top: -17px">
                <!-- <v-chip @click.prevent="clearCompanyLookupUserEntry"
                      >Clear</v-chip
                    > -->
                <v-chip class="mr10" @click.prevent="CompanyShowAll"
                  >Show All</v-chip
                >
                <v-chip class="mr10" @click.prevent="CompanySelectAll"
                  >Select All</v-chip
                >
                <v-chip class="mr10" @click.prevent="clearCompanyLookupAllEntry"
                  >Clear All</v-chip
                >
              </div>
              <span
                style="color: #00a4e4; cursor: pointer; margin-top: 20px"
                @click.stop="showCompanyTips = true"
              >
                <CustomModal
                  v-model="showCompanyTips"
                  @close="showCompanyTips = false"
                />
                Company Tips
              </span>

              <v-progress-linear
                v-if="loading"
                indeterminate
                color="primary"
                class="mt-4"
              ></v-progress-linear>
              <v-list
                max-height="300"
                ref="iCompanyList"
                @scroll="CompanyShowAll"
                outlined
                class="overflow-y-auto"
              >
                <v-list-item
                  v-for="item in companies"
                  :key="item.id"
                  :value="item"
                  @click="chooseCompany(item)"
                  class="overflow-y-auto"
                >
                  {{ item.name }}
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
          <!-- product lookup -->
          <v-row v-if="productNameOpen()">
            <v-col cols="12" v-click-outside="productClickedOut">
              <div v-for="c in choosenProduct" v-bind:key="c.id">
                <v-chip
                  class="mr-1 mt-1"
                  closable
                  @click:close="removeProduct(c)"
                  >{{ c.productName }}</v-chip
                >
                <!-- <v-icon
                      color="red-darken-2 pr-2"
                      :class="{ 'cursor-pointer': hover }"
                      left
                      @click.capture="removeProduct(c)"
                    >
                      mdi-minus-circle
                    </v-icon> -->
              </div>
              <v-text-field
                class="font-weight-small"
                variant="outlined"
                density="compact"
                label="Product Name"
                v-model="product"
                persistent-hint
                style="margin-top: 9px"
              >
              </v-text-field>
              <div style="margin-top: -17px">
                <!-- <v-chip @click.prevent="clearProductLookupUserEntry"
                      >Clear</v-chip
                    > -->
                <v-chip class="mr10" @click.prevent="ProductShowAll"
                  >Show All</v-chip
                >
                <v-chip class="mr10" @click.prevent="ProductSelectAll"
                  >Select All</v-chip
                ><v-chip
                  class="mr10"
                  @click.prevent="clearProductLookupAllEntry"
                  >Clear All</v-chip
                >
              </div>
              <v-progress-linear
                v-if="productLoading"
                indeterminate
                color="primary"
                class="mt-4"
              ></v-progress-linear>
              <v-list max-height="300" outlined class="overflow-y-auto">
                <v-list-item
                  v-for="item in products"
                  :key="item.id"
                  :value="item"
                  @click="chooseProduct(item)"
                  class="overflow-y-auto"
                >
                  {{ item.productName }}
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>

          <!-- affinity lookup -->
          <v-row>
            <v-col cols="12" v-click-outside="affinityClickedOut">
              <div v-for="c in choosenAffinity" v-bind:key="c.id">
                <v-chip
                  class="mr-1 mt-1"
                  closable
                  @click:close="removeAffinity(c)"
                  >{{ c.name }} {{ c.id }}</v-chip
                >
                <!-- <v-icon
                      color="red-darken-2 pr-2"
                      :class="{ 'cursor-pointer': hover }"
                      left
                      @click.capture="removeAffinity(c)"
                    >
                      mdi-minus-circle
                    </v-icon> -->
              </div>
              <v-text-field
                class="font-weight-small"
                variant="outlined"
                density="compact"
                label="Affinity Name"
                v-model="affinity"
                persistent-hint
                style="margin-top: 9px"
              >
              </v-text-field>
              <div style="margin-top: -17px">
                <!-- <v-chip @click.prevent="clearAffiinityLookupUserEntry"
                    >Clear</v-chip
                  > -->
                <v-chip class="mr10" @click.prevent="AffinityShowAll"
                  >Show All</v-chip
                >
                <v-chip class="mr10" @click.prevent="AffinitySelectAll"
                  >Select All</v-chip
                >
                <v-chip
                  class="mr10"
                  @click.prevent="clearAffinityLookupAllEntry"
                  >Clear All</v-chip
                >
              </div>
              <v-progress-linear
                v-if="affinityLoading"
                indeterminate
                color="primary"
                class="mt-4"
              ></v-progress-linear>
              <v-list max-height="300" outlined class="overflow-y-auto">
                <v-list-item
                  v-for="item in affinities"
                  :key="item.id"
                  :value="item"
                  @click="chooseAffinity(item)"
                  class="overflow-y-auto"
                >
                  {{ item.name }}
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>

          <!-- <VerticalSpacer :space="1"></VerticalSpacer>

            <VerticalSpacer :space="1"></VerticalSpacer>
            <VerticalSpacer :space="1"></VerticalSpacer> -->

          <v-checkbox
            label="Affinities, Loyalty/Retention, Statement Companies"
            @click="addRewardSearchCriteria"
          ></v-checkbox>
        </v-list-item>
        <v-list-item>
          <v-expand-transition mode="out-in">
            <ExtendedSearch v-show="extended_search"></ExtendedSearch>
          </v-expand-transition>
          <VerticalSpacer :space="2"></VerticalSpacer>
          <v-row class="text-center">
            <v-col>
              <v-btn
                style="width: 247px"
                color="primary"
                @click.stop="HandlerEnhancedSearch"
                >{{ EnhancedSearchName }}</v-btn
              >
            </v-col>
          </v-row>
          <v-row class="text-center">
            <v-col>
              <v-btn
                color="primary"
                :disabled="searchBtnDisabledFlag"
                @click="searchHandler"
                >search</v-btn
              >
            </v-col>
            <v-col>
              <v-btn color="primary" @click="clear">Clear</v-btn>
            </v-col>
          </v-row>
        </v-list-item>
      </v-navigation-drawer>

      <v-main>
        <v-row no-gutters>
          <v-col>
            <div class="mr-3 mb-3">
              <v-icon
                style="position: fixed; height: auto"
                color="primary"
                :size="30"
                @click.stop="drawerFn"
              >
                mdi-menu
              </v-icon>
            </div>
            <loading
              v-model:active="isLoading"
              :can-cancel="false"
              loader="dots"
              color="#007bff"
              :height="45"
              :width="75"
              :is-full-page="true"
            ></loading>
            <!-- <MainField v-if="!isLoading" :sendingWidth="resultWidthValue" /> -->
            <MainField />
          </v-col>
        </v-row>
      </v-main>
    </v-layout>
    <!-- <FooterPower /> -->
  </v-app>
  <!-- <v-footer class="d-flex flex-column pa-5" color="dark" app>
    <v-row class="d-flex w-100 justify-space-around">
      <v-col class="text-left footer-txtcolor">
        <v-footer-title>&copy; 2024 Competiscan</v-footer-title>
      </v-col>
      <v-col>
        <a class="pa-5 footer-txtcolor">About Us</a>
        <a class="pa-5 footer-txtcolor">Services</a>
        <a class="pa-5 footer-txtcolor">Careers</a>
        <a class="pa-5 footer-txtcolor">Contact Us</a>
        <a class="pa-5 footer-txtcolor">About</a>
      </v-col>
    </v-row>
  </v-footer> -->
</template>

<script>
/*eslint-disable*/
import {
  onBeforeUpdate,
  ref,
  computed,
  onMounted,
  watchEffect,
  watch,
  inject,
  onBeforeUnmount,
} from "vue";
import { useStore } from "vuex";
import MainField from "./MainField.vue";
import FooterPower from "./FooterPowerSearch.vue";
import VueCookies from "vue-cookies";

import SelectBox from "./reusable/SelectBox.vue";
import VerticalSpacer from "./reusable/VerticalSpacer.vue";
// import { VDatePicker } from "vuetify/lib/labs/components.mjs";
import CustomModal from "./reusable/CustomModal.vue";
import ExtendedSearch from "./ExtendedSearch.vue";
import moment from "moment";
import DropdownList from "./reusable/DropdownList.vue";
import Loading from "vue-loading-overlay";
import { DatePicker } from "v-calendar";
import AuthLogin from "../views/AuthLogin.vue";
// import AutoComplete from "./AutoComplete";
// import { inject } from "vue";
import "vue-loading-overlay/dist/css/index.css";
export default {
  components: {
    MainField,
    SelectBox,
    VerticalSpacer,
    CustomModal,
    DatePicker,
    // AutoComplete,
    FooterPower,
    ExtendedSearch,
    DropdownList,
    Loading,
    AuthLogin,
  },
  setup() {
    const links = [
      "Home",
      "About Us",
      "Team",
      "Services",
      "Blog",
      "Contact Us",
    ];
    const isLoading = ref(false);
    const store = useStore();
    const leftBarHeight = ref("98vh");
    // const show_checkbox = ref(false);
    const EnhancedSearchName = ref("Enhanced Search");
    const menu = ref(false);
    const date = ref(null);
    const datepick = ref();
    const showCompanyTips = ref(false);
    const firstdate = ref(null);
    const seconddate = ref(null);
    const frommenu = ref(false);
    const tomenu = ref(false);
    const andOrSelected = ref(1);
    const masks = ref({
      input: "YYYY-MM-DD",
    });
    // const injectedValue = inject("url");
    // const utility = inject("utils");
    // const send_date = ref();
    const today = new Date();
    const maxdate = computed(() => {
      var endDate = new Date(
        today.getFullYear(),
        today.getMonth() + 1,
        today.getDate()
      );
      // console.log(endDate.toISOString().slice(0, 10));
      return endDate.toISOString().slice(0, 10);
    });
    const companyLabel = ref("Company");
    const clearAllFlag = ref(false);
    const affinityLookupName = ref();
    const loading = ref(false);
    const companyLookupToggleFlag = ref(false);
    const toggleOCRFlag = ref(true);
    const mediachannel = ref([]);
    const sectorsData = ref([]);
    const resultWidthValue = ref("100%");
    const selectedDate = ref([]);
    const audience = ref([]);
    const monthSelectionTo = ref("");
    const monthSelectionFrom = ref("");
    const usaStatesAPI = ref([]);
    const campaign_language = ref([]);
    const ancillary_product = ref([]);
    const monthBoxFlag = ref(true);
    const searchDateBoxFlag = ref(false);
    const snackbar = ref(true);
    const anyOnlyModel = ref("1");
    const countrySelectedModel = ref("All");
    const panelistSelectedModel = ref("All");
    const companyLookupToggleMsg = ref("Show Lookup");
    const exactCheckbox = ref(false);
    const affinityLookupToggleFlag = ref(false);
    const affinityLookupToggleMsg = ref("Show Lookup");
    const panelistId = ref(undefined);
    const latestCompanySearchQuery = ref("");
    const dateData = [
      { name: "Select Period", value: "Select Period" },
      { name: "Less than one week ago", value: "1week" },
      { name: "Less than two weeks ago", value: "2week" },
      { name: "Less than one month ago", value: "1month" },
      { name: "Less than 3 months ago", value: "3month" },
      { name: "Less than 6 months ago", value: "6month" },
      { name: "Less than one year ago", value: "1year" },
    ];
    const tabCloseFlag = ref(false);
    const isLoadingCompany = ref(false);
    const TimeBtn = [
      { id: 0, name: "None", value: "None" },
      { id: 1, name: "12:00 AM", value: "00:00:00" },
      { id: 2, name: "12:15 AM", value: "00:15:00" },
      { id: 3, name: "12:30 AM", value: "00:30:00" },
      { id: 4, name: "12:45 AM", value: "00:45:00" },
      { id: 5, name: "12:00 AM", value: "01:00:00" },
      { id: 6, name: "12:00 AM", value: "01:15:00" },
      { id: 7, name: "12:00 AM", value: "01:30:00" },
      { id: 8, name: "12:00 AM", value: "01:45:00" },
      { id: 9, name: "12:00 AM", value: "02:00:00" },
      { id: 10, name: "12:00 AM", value: "02:15:00" },
      { id: 11, name: "12:00 AM", value: "02:30:00" },
      { id: 12, name: "12:00 AM", value: "02:45:00" },
      { id: 13, name: "12:00 AM", value: "03:00:00" },
      { id: 14, name: "12:00 AM", value: "03:15:00" },
      { id: 15, name: "12:00 AM", value: "03:30:00" },
    ];
    const companyLookupName = ref([]);
    const fromTime = ref("00:00:00");
    const ToTime = ref("23:59:59");
    const selectedCompanyNames = ref([]);
    const userEntry = ref("");
    const timeIntervals = ref([]);
    const fullTextOCRModel = ref("ocr2");
    const fullTextOCRInputModel = ref();
    const ORandInputModel = ref();
    const ORandModel = ref("AND");
    // const ocrFullText = ref();
    const FullInputModel = ref();
    const srao0 = ref();
    const srex0 = ref();
    const message = ref(null);
    const typing = ref(null);
    const debounce = ref(null);
    const searchedCompanyName = ref();
    const finalApprovedDate = ref();
    const affinityLabel = ref("Affinity");
    const companies = ref([]);
    const choosenCompanies = ref([]);
    const company = ref([]);
    const products = ref([]);
    const choosenProduct = ref([]);
    const product = ref("");
    const productLoading = ref(false);
    const affinities = ref([]);
    const choosenAffinity = ref([]);
    const affinity = ref("");
    const affinityLoading = ref(false);
    let companyIndex = ref(0);
    let iCompanyList = ref(null);
    const http = ref();
    const selectedAffinityNames = ref([]);
    const isAuth = ref(store.getters["Rawdata/getisAuthFlag"]);
    const searchedAffinityName = ref([]);
    const windowSize = {
      x: 0,
      y: 0,
    };
    const searchBtnHit = ref(store.getters["Rawdata/getsearchBtnHit"]);
    const searchBtnDisabledFlag = ref(true);
    const winHeight = ref();
    // const searchDateUsed = ref(false);
    // watchEffect(() => {
    //   if(compan)
    // });
    onBeforeUpdate(() => {
      const element = iCompanyList.value;
      // console.log("End begin", iCompanyList.value);
      let lastScrollTop = 0;
      element.onscroll = () => {
        if (element.scrollTop < lastScrollTop) {
          // upscroll
          return;
        }
        lastScrollTop = element.scrollTop <= 0 ? 0 : element.scrollTop;
        if (element.scrollTop + element.offsetHeight >= element.scrollHeight) {
          // console.log("End");
        }
      };
    });
    onMounted(() => {
      http.value = inject("http");
      window.addEventListener("beforeunload", function (event) {
        if (!tabCloseFlag) {
          // This code will run when the user refreshes the page
          // You may not want to display the confirmation message for page refresh
          return;
        }
      });
      // console.log(window.screen.availHeight, window.screen.availWidth);
      // console.log(http.value.api7BaseUrl, "apiBasePath");

      // let view = this;
      // console.log(injectedValue("FETCH_MEDIA"), 9);
      // document
      //   .getElementsByClassName(
      //     "v-list v-theme--myCustomTheme bg-transparent v-list--density-default v-list--one-line"
      //   )[0]
      //   .removeAttribute("tabindex");
      // isLoading.value = true;
      // setTimeout(() => {

      // }, 5000);

      // console.log("sss", loading.value);
      generateMonthYearArray();
      updateMonthYearArray();
      // console.log(mediachannel.value, 2233);
    });

    // watch(company, (newQuery, oldQuery) => {
    //   if (newQuery.length > 1) {
    //     // setTimeout(() => {
    //     //   console.log("Company");
    //     // }, 500000);
    //     // typing.value = null;
    //     // message.value = o;
    //     if (newQuery !== oldQuery) {
    //       // API call based on the latest search query
    //       companyAPICall(newQuery);
    //     }
    //   } else {
    //     companies.value = [];
    //   }
    // });

    const handleBeforeUnload = (event) => {
      // Cancel the event
      // console.log(event);
      event.preventDefault();
      // Chrome requires returnValue to be set
      event.returnValue = "";
      tabCloseFlag.value = true;
      // Prompt the user before closing the tab
      const confirmationMessage = "Are you sure ?";
      event.returnValue = confirmationMessage;

      // You can perform additional logic or cleanup here before the tab is closed
    };

    onBeforeUnmount(() => {
      localStorage.clear();
      window.removeEventListener("beforeunload", handleBeforeUnload);
    });

    watch(latestCompanySearchQuery, (newQuery, oldQuery) => {
      if (newQuery.length > 1) {
        if (newQuery !== oldQuery) {
          //       // API call based on the latest search query
          let timer;
          if (timer) clearTimeout(timer);
          setTimeout(() => {
            companyAPICall(newQuery);
          }, 300);
        }
      } else {
        companies.value = [];
        loading.value = false;
      }
    });
    watch(product, (o) => {
      if (o.length > 2) {
        let productStoreNames =
          store.getters["Rawdata/getproductCompaniesNamesGetters"];
        productLoading.value = true;
        products.value = [];
        clearTimeout(debounce.value);
        debounce.value = setTimeout(() => {
          typing.value = null;
          message.value = o;
          let result = productStoreNames.filter((s) =>
            s.productName.includes(o)
          );
          productLoading.value = false;
          products.value = result;
        }, 600);
      } else {
        products.value = [];
      }
    });

    // watch(window.innerWidth, (o) => {
    //   console.log(o);
    // });
    watch(affinity, (o) => {
      if (o.length > 2) {
        affinityLoading.value = true;
        affinities.value = [];
        clearTimeout(debounce.value);
        debounce.value = setTimeout(() => {
          typing.value = null;
          message.value = o;
          affinityAPICall(o);
        }, 600);
      } else {
        affinities.value = [];
      }
    });

    async function affinityAPICall(o) {
      fetch(`${http.value.product}data/affinity`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "eyJraWQiOiJxUytUWFFjcitCXC9mK3ZBdzJ2QWl4c1hqUVZPZFRVaURrM2RIQkVlZ1hNaz0iLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiI5NDI2N2NjNC02MDViLTRhMmItOTlhZi1mMDE5MDk3NTUyODYiLCJldmVudF9pZCI6IjU2YWJlMDkzLTJjYTgtNDA1Zi1iN2NkLWUxODM0YTBkMGEyYiIsInRva2VuX3VzZSI6ImFjY2VzcyIsInNjb3BlIjoiYXdzLmNvZ25pdG8uc2lnbmluLnVzZXIuYWRtaW4iLCJhdXRoX3RpbWUiOjE2ODg0NjA3MjQsImlzcyI6Imh0dHBzOlwvXC9jb2duaXRvLWlkcC51cy13ZXN0LTIuYW1hem9uYXdzLmNvbVwvdXMtd2VzdC0yX2ZMWVVwdVBWZyIsImV4cCI6MTY4ODQ2MjUyNCwiaWF0IjoxNjg4NDYwNzI0LCJqdGkiOiIyNjhjMDY0Yy1lNWNhLTRhNTQtODQ2My0wZWIxOWY2MDEwNzIiLCJjbGllbnRfaWQiOiIyZzU0cWtxajNwbHRqcWN2ZDE4YmR2Z3F2MCIsInVzZXJuYW1lIjoiYXJ2aW5kbm1nIn0.efQRa1v2ZkzEL62JO9VEuQpglne1jXJ8SG70W-suPAag97NoCAkXAB2AXNGyMJ7AKiTdDRDbwKTFeVOkq2fJFJQ_RPfh7ZbijtQwrw1bvxcM17RyQXZaRKDQ_seSeDeg8pU3upUwBf7IgBP4OLPXRUNbNzmecIrnXkG9CRWeWoDx6AXDP8FzIMYBjWeb5birOBPGaAziltLt85SmCYui45Qwq4aZq9bev1J14TIYy2WWDwg2MaCMFiw5pTw7KpIfyUYMHBJ4T-qgpnqQmYRj-wbWj7Ljjg3HoRkBXJOjJS_lKedilLSIYjgVpPDQxxJEoGXz7-X7gYwAGXZNnG8W9g",
          Accept: "*/*",
        },
        body: JSON.stringify({ affinity: o }),
      })
        .then((response) => {
          response.json().then((data) => {
            console.log("111data", data);
            for (var i = 0; i < data?.length; i++) {
              affinities.value.push({
                id: data[i].affinityID,
                name: data[i].affinityName,
              });
            }
            affinityLoading.value = false;
          });
          // console.log("affinities", affinities.value);
        })
        .catch(function (e) {
          console.log(e);
        });
    }

    watchEffect(() => {
      // console.log(store.getters["Rawdata/getisAuthFlag"], " flag");
      // if(store.getters["Rawdata/getisAuthFlag"]){
      //   // alert(true)
      //   isAuth.value = store.getters["Rawdata/getisAuthFlag"]
      // }
      let useridData = store.getters["Rawdata/getUpdatedRawDataGetter"];
      let mediauserIdLen = useridData["media"].length;
      let sectoruserIdLen = useridData["sector"].length;
      let audienceuserIdLen = useridData["audience"].length;
      // console.log(mediauserIdLen, "mediauserIdLen")
      window.addEventListener("beforeunload", function (event) {
        // Set a flag in sessionStorage indicating the page is unloading
        sessionStorage.setItem("unloading", "true");
      });

      window.addEventListener("load", function () {
        // Check if the page was reloaded or opened fresh
        const isReload = sessionStorage.getItem("unloading") === "true";

        if (isReload) {
          //console.log('Page was reloaded');
          VueCookies.remove("callLastSearch");
          VueCookies.remove("callLastResult");
          // Clear the flag to reset for future unloads
          sessionStorage.removeItem("unloading");
        } else {
          VueCookies.remove("callLastSearch");
          VueCookies.remove("callLastResult");
          //console.log('Page was loaded fresh or tab/window was reopened');
        }

        // Additional logic for detecting tab close
        window.addEventListener("beforeunload", function () {
          if (!sessionStorage.getItem("unloading")) {
            //console.log('The user is closing the tab or browser.');
            VueCookies.remove("callLastSearch");
            VueCookies.remove("callLastResult");
            // Custom logic for tab/browser close
          }
        });
      });

      if (
        Object.keys(store.getters["Rawdata/getsearchDateSelection"]).length !==
        0
      ) {
        let getterData = store.getters["Rawdata/getsearchDateSelection"];
        // console.log(getterData, "get");
        if (getterData["dropdownDate"]) {
          let difID = getterData["dropdownDate"];
          for (const t in dateData) {
            if (difID.includes(dateData[t].value)) {
              selectedDate.value = dateData[t];
              searchDateHandler(dateData[t].value);
            }
          }
        }
        if (getterData["dropdownStart"]) {
          monthSelectionFrom.value = getterData["dropdownStart"][0];
          monthSelectionTo.value = getterData["dropdownStart"][1];
          monthDropdownHandler();
        }
        if (getterData["approvedDate"]) {
          firstdate.value = getterData["approvedDate"][0];
          seconddate.value = getterData["approvedDate"][2];
        }
        if (getterData["panelists"]) {
          panelistId.value = getterData["panelists"];
        }
        if (getterData["country"]) {
          countrySelectedModel.value = getterData["country"];
        }
        if (getterData["company"]) {
          company.value = getterData["company"];
        }
        if (getterData["choosenCompanies"]) {
          choosenCompanies.value = getterData["choosenCompanies"];
        }
        if (getterData["affinity_association"]) {
          affinity.value = getterData["affinity_association"];
        }
        if (getterData["productName"]) {
          affinity.value = getterData["productName"];
        }
      }

      if (store.getters["Rawdata/getOcrFullTextSearch"]) {
        let temp = store.getters["Rawdata/getOcrFullTextSearch"];
        if (temp.searchType === "ocr_fulltext2") {
          toggleOCRFlag.value = !toggleOCRFlag.value;
          if (temp.searchKey && temp.searchKey2) {
            ORandInputModel.value = temp.searchKey;
            FullInputModel.value = temp.searchKey2;
            if (temp.search_type_and == "1") {
              andOrSelected.value = temp.search_type_and;
            } else {
              andOrSelected.value = temp.search_type_and;
            }
            FullTextInputFnHandler();
            OCRInputFnHandler();
          }
          if (temp.searchKey) {
            ORandInputModel.value = temp.searchKey;
            // ORandModel.value = temp.searchType;
            OCRInputFnHandler();
          } else if (temp.searchKey2) {
            // ORandModel.value = temp.searchType;
            FullInputModel.value = temp.searchKey2;
            FullTextInputFnHandler();
          }
        } else if (temp.searchType === "ocr2") {
          ORandInputModel.value = temp.searchKey;
          fullTextOCRModel.value = temp.searchType;
          OCRRadio();
        } else if (temp.searchType === "fulltext2") {
          ORandInputModel.value = temp.searchKey2;
          fullTextOCRModel.value = temp.searchType;
          fullTextRadio();
        }
      }
      if (store.getters["Rawdata/getsearchBtnHit"]) {
        searchHandler();
      }
      // console.log("ocrModel", fullTextOCRInputModel.value);
      // console.log("ORandInputModel", ORandInputModel.value);
      // console.log("userEntry", userEntry.value);
      // ocrFullText.value = {
      //   key: fullTextOCRInputModel.value,
      //   search_type_set: fullTextOCRModel.value,
      //   search_type_and: 1,
      //   key2: fullTextOCRModel.value == "fulltext2" ? "full" : "",
      //   search_type: "ocr2",
      //   search_option: "boolean",
      // };
      let storeData = store.getters["Rawdata/getDropdownDataAPI"];

      if (
        storeData &&
        mediauserIdLen === 0 &&
        sectoruserIdLen === 0 &&
        audienceuserIdLen === 0
      ) {
        mediachannel.value = storeData.mediachannel;
        sectorsData.value = storeData.sectors;
        audience.value = storeData.audience;
        usaStatesAPI.value = storeData.states;
        ancillary_product.value = storeData.ancillary_product;
        campaign_language.value = storeData.campaign_language;
        // console.log("sss", campaign_language.value);
        store.dispatch(
          "Sector/setresponseMechanismAPIAction",
          storeData.response_machanism
        );
        isLoading.value = false;
      } else {
        isLoading.value = true;
        mediachannel.value = useridData["media"];
        sectorsData.value = useridData["sector"];
        audience.value = useridData["audience"];
      }

      // if (!toggleOCRFlag.value) {
      //   ocrFullText.value = {
      //     key: ORandInputModel.value,
      //     search_type_set: fullTextOCRModel.value,
      //     search_type_and:
      //       ORandModel.value === "AND" ? 1 : ORandModel.value === "OR" ? 0 : "",
      //     key2: FullInputModel.value,
      //     search_type: "ocr_fulltext2",
      //     search_option: "boolean",
      //   };
      // }
      // console.log(anyOnlyModel.value);
      // console.log(window);
      if (firstdate.value) {
        let date = moment(firstdate.value).format("YYYY-MM-DD");
        // console.log(moment(date, "YYYY-MM-DD", true).isValid(), 99);
        // console.log(date, "date");
        if (moment(date, "YYYY-MM-DD", true).isValid()) {
          store.dispatch("Rawdata/setfromDateAction", date);
        }
      }
      if (seconddate.value) {
        let date = moment(seconddate.value).format("YYYY-MM-DD");
        // console.log(moment(date, "YYYY-MM-DD", true).isValid(), 99);
        // console.log(date, "date");
        if (moment(date, "YYYY-MM-DD", true).isValid()) {
          store.dispatch("Rawdata/setfromDateAction", date);
        }
      }
      searchBtnDisabledFlag.value =
        store.getters["Rawdata/getsearchBtnDisabledFlagGetters"];
      // console.log(searchBtnDisabledFlag.value);
      // let betweenTime = store.getters["Rawdata/getbetweenTimePayloadGetters"];
      // let andTime = store.getters["Rawdata/getAndTimePayloadGetters"];
      // if (betweenTime || andTime) {
      //   save_date();
      // }
      // console.log("End begin", iCompanyList.value);
      if (anyOnlyModel.value == 1) {
        srao0.value = 0;
      } else if (anyOnlyModel.value == 2) {
        srao0.value = 1;
      }

      if (exactCheckbox.value) {
        srex0.value = 1;
      }
    });

    let monthYearArray = ref(["Select Period"]);

    // function generateMonthYearArray() {
    //   const currentYear = new Date().getFullYear();
    //   const startYear = 2002;

    //   for (let year = startYear; year <= currentYear; year++) {
    //     for (let month = 0; month < 12; month++) {
    //       const monthValue = `${year}-${(month + 1)
    //         .padStart(2, "0")}`;
    //       const monthName = new Date(year, month).toLocaleString("default", {
    //         month: "long",
    //         year: "numeric",
    //       });
    //       monthYearArray.value.push({
    //         id: monthYearArray.value.length + 1,
    //         name: monthName,
    //         value: monthValue,
    //       });
    //     }
    //   }
    // }
    function handleInput() {
      // Optional: Implementing debounce to wait for user input to settle
      clearTimeout(debounce.value);
      debounce.value = setTimeout(() => {
        latestCompanySearchQuery.value = company.value;
      }, 800); // Adjust the debounce time according to your requirements
    }

    // function deBounce(companyAPICall(newQuery), t) {
    //   let timer;
    //   return function (...args) {
    //     if (timer) clearTimeout(timer);
    //     setTimeout(() => {
    //       companyAPICall(newQuery);
    //     }, t);
    //   };
    // }

    function companyAPICall(o) {
      // console.log(o, "o");
      loading.value = true;
      fetch(`${http.value.product}data/company`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "eyJraWQiOiJxUytUWFFjcitCXC9mK3ZBdzJ2QWl4c1hqUVZPZFRVaURrM2RIQkVlZ1hNaz0iLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiI5NDI2N2NjNC02MDViLTRhMmItOTlhZi1mMDE5MDk3NTUyODYiLCJldmVudF9pZCI6IjU2YWJlMDkzLTJjYTgtNDA1Zi1iN2NkLWUxODM0YTBkMGEyYiIsInRva2VuX3VzZSI6ImFjY2VzcyIsInNjb3BlIjoiYXdzLmNvZ25pdG8uc2lnbmluLnVzZXIuYWRtaW4iLCJhdXRoX3RpbWUiOjE2ODg0NjA3MjQsImlzcyI6Imh0dHBzOlwvXC9jb2duaXRvLWlkcC51cy13ZXN0LTIuYW1hem9uYXdzLmNvbVwvdXMtd2VzdC0yX2ZMWVVwdVBWZyIsImV4cCI6MTY4ODQ2MjUyNCwiaWF0IjoxNjg4NDYwNzI0LCJqdGkiOiIyNjhjMDY0Yy1lNWNhLTRhNTQtODQ2My0wZWIxOWY2MDEwNzIiLCJjbGllbnRfaWQiOiIyZzU0cWtxajNwbHRqcWN2ZDE4YmR2Z3F2MCIsInVzZXJuYW1lIjoiYXJ2aW5kbm1nIn0.efQRa1v2ZkzEL62JO9VEuQpglne1jXJ8SG70W-suPAag97NoCAkXAB2AXNGyMJ7AKiTdDRDbwKTFeVOkq2fJFJQ_RPfh7ZbijtQwrw1bvxcM17RyQXZaRKDQ_seSeDeg8pU3upUwBf7IgBP4OLPXRUNbNzmecIrnXkG9CRWeWoDx6AXDP8FzIMYBjWeb5birOBPGaAziltLt85SmCYui45Qwq4aZq9bev1J14TIYy2WWDwg2MaCMFiw5pTw7KpIfyUYMHBJ4T-qgpnqQmYRj-wbWj7Ljjg3HoRkBXJOjJS_lKedilLSIYjgVpPDQxxJEoGXz7-X7gYwAGXZNnG8W9g",
          Accept: "*/*",
        },
        body: JSON.stringify({ get_company: o }),
      })
        .then((response) => {
          response.json().then((data) => {
            // console.log("111data", data);
            if (o === latestCompanySearchQuery.value) {
              if (companies.value.length > 0) {
                companies.value = [];
              }
              for (var i = 0; i < data?.length; i++) {
                companies.value.push({
                  id: data[i].companyID,
                  name: data[i].companyName,
                });
              }
            }

            // console.log(companies.value, "comp");
            // console.log(o, "o");
            // console.log(company.value, "company");
            loading.value = false;
          });
        })
        .catch(function (e) {
          console.log(e);
        });
    }
    function generateMonthYearArray() {
      const monthNames = [
        "Select Month",
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      const currentYear = new Date().getFullYear();
      let currentMonth = new Date().getMonth() + 1; // Adding 1 because getMonth() returns zero-based index

      const monthYearArray = [
        { id: 0, name: "Select Month", value: "Select Month" },
      ];

      for (let year = currentYear; year >= 2002; year--) {
        const minMonth = year === 2002 ? 1 : 0;

        for (let month = currentMonth; month > minMonth; month--) {
          const monthName = monthNames[month];
          const yearMonth = {
            id: (year - 2002) * 12 + month,
            name: `${monthName} ${year}`,
            value: `${year}-${month < 10 ? "0" + month : month}`,
          };
          monthYearArray.push(yearMonth);
        }

        // Reset current month for the first year (2002)
        currentMonth = 12;
      }

      return monthYearArray;
    }

    // Example usage:
    const sortedMonthYearArray = ref(generateMonthYearArray());
    // console.log(sortedMonthYearArray, "mo");

    function drawerFn() {
      drawer.value = !drawer.value;
      if (resultWidthValue.value === "80%") {
        resultWidthValue.value = "100%";
      } else {
        resultWidthValue.value = "80%";
      }
    }

    function clickedOut() {
      companies.value = [];
      company.value = "";
    }

    function productClickedOut() {
      products.value = [];
      product.value = "";
    }

    function affinityClickedOut() {
      affinities.value = [];
      affinity.value = "";
    }

    async function companyLookupFetch() {
      // console.log(userEntry);
      if (userEntry.value !== "") {
        setTimeout(() => {
          isLoadingCompany.value = true;
          fetch(`${http.value.product}data/company`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization:
                "eyJraWQiOiJxUytUWFFjcitCXC9mK3ZBdzJ2QWl4c1hqUVZPZFRVaURrM2RIQkVlZ1hNaz0iLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiI5NDI2N2NjNC02MDViLTRhMmItOTlhZi1mMDE5MDk3NTUyODYiLCJldmVudF9pZCI6IjU2YWJlMDkzLTJjYTgtNDA1Zi1iN2NkLWUxODM0YTBkMGEyYiIsInRva2VuX3VzZSI6ImFjY2VzcyIsInNjb3BlIjoiYXdzLmNvZ25pdG8uc2lnbmluLnVzZXIuYWRtaW4iLCJhdXRoX3RpbWUiOjE2ODg0NjA3MjQsImlzcyI6Imh0dHBzOlwvXC9jb2duaXRvLWlkcC51cy13ZXN0LTIuYW1hem9uYXdzLmNvbVwvdXMtd2VzdC0yX2ZMWVVwdVBWZyIsImV4cCI6MTY4ODQ2MjUyNCwiaWF0IjoxNjg4NDYwNzI0LCJqdGkiOiIyNjhjMDY0Yy1lNWNhLTRhNTQtODQ2My0wZWIxOWY2MDEwNzIiLCJjbGllbnRfaWQiOiIyZzU0cWtxajNwbHRqcWN2ZDE4YmR2Z3F2MCIsInVzZXJuYW1lIjoiYXJ2aW5kbm1nIn0.efQRa1v2ZkzEL62JO9VEuQpglne1jXJ8SG70W-suPAag97NoCAkXAB2AXNGyMJ7AKiTdDRDbwKTFeVOkq2fJFJQ_RPfh7ZbijtQwrw1bvxcM17RyQXZaRKDQ_seSeDeg8pU3upUwBf7IgBP4OLPXRUNbNzmecIrnXkG9CRWeWoDx6AXDP8FzIMYBjWeb5birOBPGaAziltLt85SmCYui45Qwq4aZq9bev1J14TIYy2WWDwg2MaCMFiw5pTw7KpIfyUYMHBJ4T-qgpnqQmYRj-wbWj7Ljjg3HoRkBXJOjJS_lKedilLSIYjgVpPDQxxJEoGXz7-X7gYwAGXZNnG8W9g",
            },
            body: JSON.stringify({ get_company: userEntry.value }),
          }).then((response) => {
            response.json().then((data) => {
              // console.log("111data", data);
              searchedCompanyName.value = data;
              isLoadingCompany.value = false;
            });
          });
        }, 1500);
      }
    }

    function chooseCompany(c) {
      // console.log(c, "c")
      let is_company = choosenCompanies.value.filter((o) => c.id === o.id);
      if (Array.isArray(is_company)) {
        if (is_company.length === 0) {
          choosenCompanies.value.push(c);
          companies.value = companies.value.filter((o) => c.id !== o.id);
          console.log("comp", choosenCompanies.value);
          store.dispatch(
            "Rawdata/setCompanyDataAction",
            choosenCompanies.value
          );
          const multiPay = {
            event: "Company",
            value: choosenCompanies.value,
          };
          store.dispatch("Rawdata/setSearchCriteriaMultiTextboxes", multiPay);
          console.log("view.companies", companies.value);
        }
      }
      // clickedOut();
    }

    function chooseProduct(c) {
      // console.log(c, "c");
      let is_company = choosenProduct.value.filter((o) => c.id === o.id);
      if (Array.isArray(is_company)) {
        if (is_company.length === 0) {
          choosenProduct.value.push(c);
          products.value = products.value.filter((o) => c.id !== o.id);
          // console.log("comp", choosenProduct.value);
          store.dispatch(
            "Rawdata/setProductNamesDataAction",
            choosenProduct.value
          );
          const multiPay = {
            event: "Product Name",
            value: choosenProduct.value,
          };
          store.dispatch("Rawdata/setSearchCriteriaMultiTextboxes", multiPay);
          // console.log("view.companies", companies.value);
        }
      }
      // clickedOut();
    }

    function chooseAffinity(c) {
      // console.log(choosenAffinity.value, "choosenAffinity.value");
      let is_company = choosenAffinity.value.filter((o) => c.id === o.id);
      if (Array.isArray(is_company)) {
        if (is_company.length === 0) {
          choosenAffinity.value.push(c);
          affinities.value = affinities.value.filter((o) => c.id !== o.id);
          store.dispatch(
            "Rawdata/setAffinityDataAction",
            choosenAffinity.value
          );
          const multiPay = {
            event: "Affinity/Association ",
            value: choosenAffinity.value,
          };
          store.dispatch("Rawdata/setSearchCriteriaMultiTextboxes", multiPay);
          // console.log("comp", choosenAffinity.value);
          // console.log("view.companies", companies.value);
        }
      }
      // clickedOut();
    }
    const isLoadingAffinity = ref(false);
    function affinityLookupFetch() {
      // console.log(affinityLookupName.value);
      setTimeout(() => {
        isLoadingAffinity.value = true;

        fetch(`${http.value.product}data/affinity`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "eyJraWQiOiJxUytUWFFjcitCXC9mK3ZBdzJ2QWl4c1hqUVZPZFRVaURrM2RIQkVlZ1hNaz0iLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiI5NDI2N2NjNC02MDViLTRhMmItOTlhZi1mMDE5MDk3NTUyODYiLCJldmVudF9pZCI6IjU2YWJlMDkzLTJjYTgtNDA1Zi1iN2NkLWUxODM0YTBkMGEyYiIsInRva2VuX3VzZSI6ImFjY2VzcyIsInNjb3BlIjoiYXdzLmNvZ25pdG8uc2lnbmluLnVzZXIuYWRtaW4iLCJhdXRoX3RpbWUiOjE2ODg0NjA3MjQsImlzcyI6Imh0dHBzOlwvXC9jb2duaXRvLWlkcC51cy13ZXN0LTIuYW1hem9uYXdzLmNvbVwvdXMtd2VzdC0yX2ZMWVVwdVBWZyIsImV4cCI6MTY4ODQ2MjUyNCwiaWF0IjoxNjg4NDYwNzI0LCJqdGkiOiIyNjhjMDY0Yy1lNWNhLTRhNTQtODQ2My0wZWIxOWY2MDEwNzIiLCJjbGllbnRfaWQiOiIyZzU0cWtxajNwbHRqcWN2ZDE4YmR2Z3F2MCIsInVzZXJuYW1lIjoiYXJ2aW5kbm1nIn0.efQRa1v2ZkzEL62JO9VEuQpglne1jXJ8SG70W-suPAag97NoCAkXAB2AXNGyMJ7AKiTdDRDbwKTFeVOkq2fJFJQ_RPfh7ZbijtQwrw1bvxcM17RyQXZaRKDQ_seSeDeg8pU3upUwBf7IgBP4OLPXRUNbNzmecIrnXkG9CRWeWoDx6AXDP8FzIMYBjWeb5birOBPGaAziltLt85SmCYui45Qwq4aZq9bev1J14TIYy2WWDwg2MaCMFiw5pTw7KpIfyUYMHBJ4T-qgpnqQmYRj-wbWj7Ljjg3HoRkBXJOjJS_lKedilLSIYjgVpPDQxxJEoGXz7-X7gYwAGXZNnG8W9g",
          },
          body: JSON.stringify({ affinity: affinityLookupName.value }),
        }).then((response) => {
          response.json().then((data) => {
            // console.log("111data", data);
            searchedAffinityName.value = data;
            isLoadingAffinity.value = false;
          });
        });
      }, 1500);
    }

    // function ProductLookupFetch() {
    //   console.log(ProductLookupName.value);
    // }

    function clearCompanyLookupUserEntry() {
      company.value = "";
      fullTextOCRModel.value = "ocr2";
    }

    function clearCompanyLookupAllEntry() {
      company.value = "";
      companies.value = [];
      choosenCompanies.value = [];
      store.dispatch("Rawdata/setCompanyDataAction", choosenCompanies.value);
      const multiPay = {
        event: "Company",
        value: choosenCompanies.value,
      };
      store.dispatch("Rawdata/setSearchCriteriaMultiTextboxes", multiPay);
    }

    function CompanySelectAll() {
      choosenCompanies.value = companies.value;
      store.dispatch("Rawdata/setCompanyDataAction", choosenCompanies.value);
      const multiPay = {
        event: "Company",
        value: choosenCompanies.value,
      };
      store.dispatch("Rawdata/setSearchCriteriaMultiTextboxes", multiPay);
      clickedOut();
    }
    async function CompanyShowAll({
      target: { scrollTop, clientHeight, scrollHeight },
    }) {
      if (scrollTop + clientHeight >= scrollHeight) {
        if (companies.value.length === 0) {
          companies.value = [];
          loading.value = true;
          fetch(`${http.value.api5BaseUrl}all/company`, {
            method: "GET",
            headers: { "Content-Type": "application/json" },
          }).then((res) => {
            res.json().then(async (e) => {
              companyLookupName.value.push(e.data);
              for (let i = 0; i < companyLookupName.value.length; i++) {
                if (companyLookupName.value[i].isApprovedCo !== 0) {
                  // console.log("XXX0", companyLookupName.value[i]);
                  companies.value.push({
                    id: companyLookupName.value[i].companyID,
                    name: companyLookupName.value[i].companyName,
                  });
                }

                // companyIndex.value = i;
              }
              // console.log("companies data", companies);
              loading.value = false;
            });
          });
        } else {
          companyLookupName.value[0]
            .slice(companyIndex.value, companyIndex.value + 10000)
            .map((item, i) => {
              companyIndex.value += 1;
              // console.log("SSSs", item, i, companyIndex.value);
              companies.value.push({
                id: item.companyID,
                name: item.companyName,
              });
              // placeIDs.push(item.place_id);
            });
        }
      }

      // companyLookupName.value = "";
    }
    function toggleHandler() {
      toggleOCRFlag.value = !toggleOCRFlag.value;
      FullInputModel.value = null;
      // console.log("XXXX", ORandModel.value);
      let temp = {};
      if (toggleOCRFlag.value) {
        if (fullTextOCRModel.value === "fulltext2") {
          temp = {
            product_headline: ORandInputModel.value,
            text_match_op: "product_headline,and",
          };
        } else if (
          fullTextOCRModel.value === "ocr2" &&
          ORandInputModel.value !== undefined
        ) {
          temp = {
            dts_val: ORandInputModel.value.toUpperCase(),
            text_match_op: "dts_val,and",
          };
        }
        store.dispatch("Rawdata/setocrFullTextPayloadAction", temp);
      } else {
        fullTextOCRModel.value = "ocr2";
        if (ORandInputModel.value && ORandInputModel.value.length > 0) {
          temp = {
            dts_val: ORandInputModel.value.toUpperCase(),
            text_match_op: "dts_val,and",
          };
        }
        store.dispatch("Rawdata/setocrFullTextPayloadAction", temp);
      }
    }

    function clearAffiinityLookupUserEntry() {
      affinity.value = "";
    }

    function clearAffinityLookupAllEntry() {
      affinity.value = "";
      affinities.value = [];
      choosenAffinity.value = [];
      store.dispatch("Rawdata/setAffinityDataAction", choosenAffinity.value);
      const multiPay = {
        event: "Affinity/Association ",
        value: choosenAffinity.value,
      };
      store.dispatch("Rawdata/setSearchCriteriaMultiTextboxes", multiPay);
    }

    function AffinitySelectAll() {
      choosenAffinity.value = affinities.value;
      store.dispatch("Rawdata/setAffinityDataAction", choosenAffinity.value);
      const multiPay = {
        event: "Affinity/Association ",
        value: choosenAffinity.value,
      };
      store.dispatch("Rawdata/setSearchCriteriaMultiTextboxes", multiPay);
    }
    function AffinityShowAll() {
      setTimeout(() => {
        affinityLoading.value = true;
        fetch(`${http.value.api5BaseUrl}all/affinity`, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        }).then((response) => {
          response.json().then(async (data) => {
            // sector = await resolveAfter2Seconds();
            // console.log("2data", data);
            let temp = data.data;
            for (var i = 0; i < temp.length; i++) {
              affinities.value.push({
                id: temp[i].affinityID,
                name: temp[i].affinityName,
              });
            }
            // affinities.value = data.data;
            affinityLoading.value = false;
          });
        });
      }, 1500);
    }
    function lookupHandler() {
      if (companyLookupToggleMsg.value == "Show Lookup") {
        companyLookupToggleFlag.value = true;
        companyLookupToggleMsg.value = "Hide Lookup";
        searchedCompanyName.value = selectedCompanyNames.value;
      } else {
        companyLookupToggleMsg.value = "Show Lookup";
        companyLookupToggleFlag.value = false;
      }
    }

    function affinitylookupHandler() {
      if (affinityLookupToggleMsg.value == "Show Lookup") {
        affinityLookupToggleFlag.value = true;
        affinityLookupToggleMsg.value = "Hide Lookup";
      } else {
        affinityLookupToggleMsg.value = "Show Lookup";
        affinityLookupToggleFlag.value = false;
      }
    }
    const ProductLookupToggleMsg = ref("Show Lookup");
    const ProductLookupToggleFlag = ref(false);

    function ProductlookupHandler() {
      if (ProductLookupToggleMsg.value == "Show Lookup") {
        ProductLookupToggleFlag.value = true;
        ProductLookupToggleMsg.value = "Hide Lookup";
        searchedProductName.value = selectedProductNames.value;
      } else {
        ProductLookupToggleMsg.value = "Show Lookup";
        ProductLookupToggleFlag.value = false;
      }
    }

    function clearProductLookupUserEntry() {
      ProductLookupName.value = "";
    }

    function clearProductLookupAllEntry() {
      productLoading.value = true;
      setTimeout(() => {
        product.value = "";
        products.value = [];
        choosenProduct.value = [];
        productLoading.value = false;
        store.dispatch(
          "Rawdata/setProductNamesDataAction",
          choosenProduct.value
        );
        const multiPay = {
          event: "Product Name",
          value: choosenProduct.value,
        };
        store.dispatch("Rawdata/setSearchCriteriaMultiTextboxes", multiPay);
      }, 300);
    }

    function ProductSelectAll() {
      productLoading.value = true;
      setTimeout(() => {
        choosenProduct.value = products.value;
        productLoading.value = false;
        store.dispatch(
          "Rawdata/setProductNamesDataAction",
          choosenProduct.value
        );
        const multiPay = {
          event: "Product Name",
          value: choosenProduct.value,
        };
        store.dispatch("Rawdata/setSearchCriteriaMultiTextboxes", multiPay);
      }, 300);
    }
    function ProductShowAll() {
      productLoading.value = true;
      setTimeout(() => {
        let data = store.getters["Rawdata/getproductCompaniesNamesGetters"];
        products.value = data;
        productLoading.value = false;
      }, 600);
    }

    function updateMonthYearArray() {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const currentMonthValue = `${currentYear}-${(currentDate.getMonth() + 1)
        .toString()
        .padStart(2, "0")}`;
      const currentMonthName = currentDate.toLocaleString("default", {
        month: "long",
        year: "numeric",
      });

      const lastAddedEntry = monthYearArray[monthYearArray.value.length - 1];

      if (!lastAddedEntry || lastAddedEntry.value !== currentMonthValue) {
        monthYearArray.value.push({
          id: monthYearArray.value.length + 1,
          name: currentMonthName,
          value: currentMonthValue,
        });
        // console.log("Month added to array:", monthYearArray);
      }
    }

    function clearCompanyLookupSelection() {
      companyLookupName.value = "";
    }
    function generateTimeIntervals() {
      const timeIntervals = [""];
      let hours = 0;
      let minutes = 0;
      let period = "AM";

      for (let i = 0; i < 96; i++) {
        // 96 intervals represent 24 hours (4 intervals per hour)
        const formattedHours = (hours % 12 || 12).toString().padStart(2, "0");
        const formattedMinutes = minutes.toString().padStart(2, "0");
        timeIntervals.push(`${formattedHours}:${formattedMinutes} ${period}`);

        // Increment time by 15 minutes
        minutes += 15;
        if (minutes === 60) {
          minutes = 0;
          hours++;
        }

        if (hours === 12) {
          period = "PM";
        }
      }

      return timeIntervals;
    }

    // function generate24HourTimeIntervals() {
    //   const timeIntervals = [];
    //   generateTimeIntervals
    //   for (let hours = 0; hours < 12; hours++) {
    //     for (let minutes = 0, sec = 0; minutes < 60; minutes += 15) {
    //       const formattedHours = hours.toString().padStart(2, "0");
    //       const formattedMinutes = minutes.toString().padStart(2, "0");
    //       const formattedSeconds = sec.toString().padStart(2, "0");
    //       timeIntervals.push(
    //         `${formattedHours}:${formattedMinutes}:${formattedSeconds}`
    //       );
    //     }
    //   }

    //   return timeIntervals;
    // }

    timeIntervals.value = generateTimeIntervals();
    // console.log(timeIntervals.value);
    // s----
    // function generateTimeIntervals() {
    //   const timeIntervals24Hour = [];
    //   const timeIntervals12Hour = [];

    //   for (let hours = 0; hours < 24; hours++) {
    //     for (let minutes = 0; minutes < 60; minutes += 15) {
    //       const formattedHours24 = hours.toString().padStart(2, "0");
    //       const formattedMinutes = minutes.toString().padStart(2, "0");
    //       timeIntervals24Hour.push(`${formattedHours24}:${formattedMinutes}`);

    //       const period = hours < 12 ? "AM" : "PM";
    //       const formattedHours12 = (hours % 12 || 12)
    //         .toString()
    //         .padStart(2, "0");
    //       timeIntervals12Hour.push(
    //         `${formattedHours12}:${formattedMinutes} ${period}`
    //       );
    //     }
    //   }

    //   return { timeIntervals24Hour, timeIntervals12Hour };
    // }

    // const { timeIntervals24Hour, timeIntervals12Hour } =
    //   generateTimeIntervals();
    // console.log("24-Hour Format:");
    // console.log(timeIntervals24Hour);
    // console.log("\n12-Hour Format:");
    // console.log(timeIntervals12Hour);

    // function generateTimeIntervals() {
    //   const timeIntervals24Hour = [];
    //   const timeIntervals12Hour = [];

    //   for (let hours = 0; hours < 24; hours++) {
    //     for (let minutes = 0; minutes < 60; minutes += 15) {
    //       const formattedHours24 = hours.toString().padStart(2, "0");
    //       const formattedMinutes = minutes.toString().padStart(2, "0");
    //       timeIntervals24Hour.push(`${formattedHours24}:${formattedMinutes}`);

    //       const period = hours < 12 ? "AM" : "PM";
    //       const formattedHours12 = (hours % 12 || 12)
    //         .toString()
    //         .padStart(2, "0");
    //       timeIntervals12Hour.push(
    //         `${formattedHours12}:${formattedMinutes} ${period}`
    //       );
    //     }
    //   }

    //   return {
    //     value: timeIntervals24Hour,
    //     value1: timeIntervals12Hour,
    //   };
    // }

    function searchDateUsed() {
      let dtfind = store.getters["Rawdata/getUserMonthGetters"].length;
      // console.log(dtfind);
      if (dtfind != 0) {
        return true;
      } else {
        return false;
      }
    }

    function OCRInputFnHandler() {
      let temp = {};
      let hasOcr = "";
      let hasFullText = "";
      let finalTest = "";
      if (ORandModel.value == "AND") {
        if (ORandInputModel.value || FullInputModel.value) {
          if (ORandInputModel.value && ORandInputModel.value.length > 0) {
            Object.assign(temp, {
              dts_val: ORandInputModel.value.toUpperCase(),
            });
            hasOcr = "dts_val,and";
          }
          if (FullInputModel.value && FullInputModel.value.length > 0) {
            Object.assign(temp, { product_headline: FullInputModel.value });
            hasFullText = "product_headline,and";
          }
          if (hasOcr.length > 0 || hasFullText.length > 0) {
            if (hasOcr.length > 0 && hasFullText.length > 0) {
              finalTest = [hasOcr, hasFullText].join(";");
            } else {
              finalTest = hasOcr + hasFullText;
            }
          }
          // Object.assign(temp, { text_search_join: finalTest });
          // temp = {
          //   dts_val: ORandInputModel.value.toUpperCase(),
          //   product_headline: FullInputModel.value,
          //   text_match_op: finalTest,
          // };
        }
      } else {
        if (ORandInputModel.value || FullInputModel.value) {
          if (ORandInputModel.value && ORandInputModel.value.length > 0) {
            Object.assign(temp, {
              dts_val: ORandInputModel.value.toUpperCase(),
            });
          }
          if (FullInputModel.value && FullInputModel.value.length > 0) {
            Object.assign(temp, { product_headline: FullInputModel.value });
          }
          Object.assign(temp, { text_search_join: "or" });
          // temp = {
          //   dts_val: ORandInputModel.value.toUpperCase(),
          //   product_headline: FullInputModel.value,
          // text_search_join: "or",
          // };
        }
      }
      // const searchCry = {
      //   val: temp.dts_val,
      //   column: "ocr",
      // };
      // if (searchCry.val !== undefined) {
      //   store.dispatch("Rawdata/setSearchCritertia", searchCry);
      // }
      // console.log(temp, "tempppp");
      store.dispatch("Rawdata/setocrFullTextPayloadAction", temp);
      console.log(temp);
    }

    function AndFnHandler() {
      let temp = {};
      let hasOcr = "";
      let hasFullText = "";
      if (ORandInputModel.value && ORandInputModel.value.length > 0) {
        Object.assign(temp, { dts_val: ORandInputModel.value.toUpperCase() });
        hasOcr = "dts_val,and";
      }
      if (FullInputModel.value && FullInputModel.value.length > 0) {
        Object.assign(temp, { product_headline: FullInputModel.value });
        hasFullText = "product_headline,and";
      }
      // if (hasOcr.length > 0 || hasFullText.length > 0) {
      //   Object.assign(temp, {
      //     // text_search_join: "dts_val,and;product_headline,and",
      //     text_search_join: [hasOcr, hasFullText].join(";"),
      //   });
      // }
      store.dispatch("Rawdata/setocrFullTextPayloadAction", temp);
      console.log(temp, "tempoo And");
    }

    function OrFnHandler() {
      let temp = {};
      if (ORandInputModel.value && ORandInputModel.value.length > 0) {
        Object.assign(temp, { dts_val: ORandInputModel.value.toUpperCase() });
      }
      if (FullInputModel.value && FullInputModel.value.length > 0) {
        Object.assign(temp, { product_headline: FullInputModel.value });
      }
      Object.assign(temp, { text_search_join: "or" });

      store.dispatch("Rawdata/setocrFullTextPayloadAction", temp);
      console.log(temp, "fntemp");
    }

    function FullTextInputFnHandler() {
      let temp = {};
      let hasOcr = "";
      let hasFullText = "";
      let finalTest = "";
      if (ORandModel.value == "AND") {
        if (ORandInputModel.value || FullInputModel.value) {
          if (ORandInputModel.value && ORandInputModel.value.length > 0) {
            Object.assign(temp, {
              dts_val: ORandInputModel.value.toUpperCase(),
            });
            hasOcr = "dts_val,and";
          }
          if (FullInputModel.value && FullInputModel.value.length > 0) {
            Object.assign(temp, { product_headline: FullInputModel.value });
            hasFullText = "product_headline,and";
          }
          if (hasOcr.length > 0 || hasFullText.length > 0) {
            if (hasOcr.length > 0 && hasFullText.length > 0) {
              finalTest = [hasOcr, hasFullText].join(";");
            } else {
              finalTest = hasOcr + hasFullText;
            }
          }
          // Object.assign(temp, { text_search_join: finalTest });
          // if (
          //   ORandInputModel.value !== undefined &&
          //   FullInputModel.value !== undefined
          // ) {
          //   temp = {
          //     dts_val: ORandInputModel.value.toUpperCase(),
          //     product_headline: FullInputModel.value,
          //     text_match_op: finalTest,
          //   };
          // }
        }
      } else {
        if (ORandInputModel.value || FullInputModel.value) {
          if (
            ORandInputModel.value &&
            ORandInputModel.value.length > 0 &&
            ORandInputModel.value !== undefined
          ) {
            Object.assign(temp, {
              dts_val: ORandInputModel.value.toUpperCase(),
            });
          }
          if (
            FullInputModel.value &&
            FullInputModel.value.length > 0 &&
            FullInputModel.value !== undefined
          ) {
            Object.assign(temp, { product_headline: FullInputModel.value });
          }
          Object.assign(temp, { text_search_join: "or" });
        }
      }
      // const searchCry = {
      //   val: temp.product_headline,
      //   column: "full",
      // };
      // if (searchCry.val !== undefined) {
      //   store.dispatch("Rawdata/setSearchCritertia", searchCry);
      // }

      // console.log("Rawdata", temp);
      store.dispatch("Rawdata/setocrFullTextPayloadAction", temp);
      console.log(temp);
    }

    function fullTextRadio() {
      fullTextOCRModel.value = "fulltext2";
      let temp = {};
      if (fullTextOCRModel.value === "fulltext2") {
        temp = {
          product_headline: ORandInputModel.value,
          text_match_op: "product_headline,and",
        };
      } else if (fullTextOCRModel.value === "ocr2") {
        temp = {
          dts_val: ORandInputModel.value.toUpperCase(),
          text_match_op: "dts_val,and",
        };
      }
      store.dispatch("Rawdata/setocrFullTextPayloadAction", temp);
      // console.log(temp, "temp");
    }

    function OCRRadio() {
      // console.log(fullTextOCRModel.value);
      fullTextOCRModel.value = "ocr2";
      let temp = {};
      if (fullTextOCRModel.value === "fulltext2") {
        temp = {
          product_headline: ORandInputModel.value,
          text_match_op: "product_headline,and",
        };
      } else if (
        fullTextOCRModel.value === "ocr2" &&
        ORandInputModel.value !== undefined
      ) {
        temp = {
          dts_val: ORandInputModel.value.toUpperCase(),
          text_match_op: "dts_val,and",
        };
      }
      store.dispatch("Rawdata/setocrFullTextPayloadAction", temp);
      // console.log(temp, "temp");
    }

    function fullTextOCRInputFnHandler() {
      // console.log(e.target._value);
      // console.log(fullTextOCRModel.value, "RXw");
      let temp = {};
      if (fullTextOCRModel.value === "fulltext2") {
        temp = {
          product_headline: ORandInputModel.value,
          text_match_op: "product_headline,and",
        };
      } else if (fullTextOCRModel.value === "ocr2") {
        temp = {
          dts_val: ORandInputModel.value.toUpperCase(),
          text_match_op: "dts_val,and",
        };
        // const searchCry = {
        //   val: ORandInputModel.value,
        //   column: "ocr",
        // };
        // if (searchCry.val !== undefined) {
        //   store.dispatch("Rawdata/setSearchCritertia", searchCry);
        // }
      }
      // console.log(temp, "temp");
      store.dispatch("Rawdata/setocrFullTextPayloadAction", temp);
    }

    function selectedCompanyNamesFnHandler(name) {
      // console.log(name);
      companyLabel.value = "";
      selectedCompanyNames.value = name;
      store.dispatch(
        "Rawdata/setCompanyDataAction",
        selectedCompanyNames.value
      );
    }

    function selectedAffinityNamesFnHandler() {
      // console.log(selectedAffinityNames.value, "aff");
      store.dispatch(
        "Rawdata/setAffinityDataAction",
        selectedAffinityNames.value
      );
    }
    const selectedProductNames = ref([]);
    const searchedProductName = ref([]);
    const ProductLookupName = ref();
    const isLoadingProduct = ref(false);

    function selectedProductNamesFnHandler() {
      // console.log(selectedProductNames.value, "pr");
      store.dispatch(
        "Rawdata/setProductNamesDataAction",
        selectedProductNames.value
      );
    }

    function HandlerEnhancedSearch() {
      // console.log(2, selectedDate.value);
      extended_search.value = !extended_search.value;
      if (extended_search.value) {
        EnhancedSearchName.value = "Close Enhanced Search";
      } else {
        EnhancedSearchName.value = "Enhanced Search";
      }
    }
    watch(monthSelectionTo, () => {
      let months = [];
      if (
        monthSelectionTo.value === "Select Month" &&
        monthSelectionFrom.value === "Select Month"
      ) {
        searchDateBoxFlag.value = false;
      } else {
        searchDateBoxFlag.value = true;
      }
      sortedMonthYearArray.value.forEach((e) => {
        if (e.id !== 0) {
          months.push(e.value);
        }
      });
      const start = months.indexOf(monthSelectionFrom.value);
      const end = months.indexOf(monthSelectionTo.value);
      if (
        monthSelectionTo.value &&
        monthSelectionFrom.value &&
        start >= 0 &&
        end >= 0
      ) {
        if (start < end) {
          monthSelectionTo.value = monthSelectionFrom.value;
          monthDropdownHandler();
          alert("End month cannot be less than first month");
          monthSelectionTo.value = monthSelectionFrom.value;
        }
      }
      if (monthSelectionTo.value === "Select Month") {
        searchDateBoxFlag.value = false;
      } else {
        searchDateBoxFlag.value = true;
      }
    });
    watch(monthSelectionFrom, () => {
      let months = [];
      if (
        monthSelectionFrom.value === "Select Month" &&
        monthSelectionTo.value === "Select Month"
      ) {
        searchDateBoxFlag.value = false;
      } else {
        searchDateBoxFlag.value = true;
      }
      sortedMonthYearArray.value.forEach((e) => {
        if (e.id !== 0) {
          months.push(e.value);
        }
      });
      const start = months.indexOf(monthSelectionFrom.value);
      const end = months.indexOf(monthSelectionTo.value);
      if (
        monthSelectionFrom.value &&
        monthSelectionTo.value &&
        start >= 0 &&
        end >= 0
      ) {
        if (end > start) {
          monthSelectionFrom.value = monthSelectionTo.value;
          monthDropdownHandler();
          alert("End month cannot be less than first month");
          monthSelectionFrom.value = monthSelectionTo.value;
        }
      }

      if (
        monthSelectionTo.value === null ||
        monthSelectionFrom.value === null
      ) {
        searchDateBoxFlag.value = false;
      }
      if (
        monthSelectionTo.value !== "Select Month" ||
        monthSelectionFrom.value !== "Select Month"
      ) {
        searchDateBoxFlag.value = true;
      }
      if (
        monthSelectionTo.value === "Select Month" &&
        monthSelectionFrom.value === "Select Month"
      ) {
        // alert("yup");
        searchDateBoxFlag.value = false;
      }
    });

    function saveResult(payload) {
      console.log(payload, "payload");
      let userid = VueCookies.get("user_id");
      // console.log(userid, "userid");
      payload = { ...payload, ...{ userID: userid ? userid : 6278 } };
      fetch(`${http.value.savesearch}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }).then((response) =>
        response
          .json()
          .then((data) => console.log(data))
          .catch((err) => console.log(err))
      );
    }
    function monthDropdownHandler() {
      // console.log(e);
      if (monthSelectionTo.value || monthSelectionFrom.value) {
        // if (monthSelectionTo.value !== "") {
        //   if (monthSelectionFrom.value > monthSelectionTo.value) {
        //     monthSelectionTo.value = sortedMonthYearArray.value[0].name;
        //     alert("Second month cannot be less than first month");
        //   }
        // }
        let toMonth = new Date(monthSelectionTo.value).getMonth() + 1;
        let toYear = new Date(monthSelectionTo.value).getFullYear();
        let fromMonth = new Date(monthSelectionFrom.value).getMonth() + 1;
        let monthsHas31 = [1, 3, 5, 7, 8, 10, 12];
        let febMonth = [2];
        let date = null;
        let fromYear = new Date(monthSelectionFrom.value).getFullYear();

        let dateStatus31Days = monthsHas31.includes(toMonth);
        let dateStatusFeb = febMonth.includes(toMonth);
        // console.log(dateStatus31Days, "dateStatus31Days");
        // console.log(dateStatusFeb, "dateStatusFeb");
        if (dateStatus31Days && !dateStatusFeb) {
          date = 31;
        } else if (dateStatusFeb) {
          if (toYear % 4 === 0) {
            date = 29;
          } else {
            date = 28;
          }
        } else {
          date = 30;
        }
        if (fromMonth <= 9) {
          fromMonth = `0${fromMonth}`;
        }
        if (toMonth <= 9) {
          toMonth = `0${toMonth}`;
        }
        // console.log(fromMonth, "month");
        let finalpayloaddate = "";
        if (toMonth && toYear && fromMonth && fromYear) {
          finalpayloaddate = `S${fromYear}-${fromMonth}-01T00:00:00E${toYear}-${toMonth}-${date}T23:59:59`;
          // console.log(
          //   `S${fromYear}-"0"${fromMonth}-01T00:00:00E${toYear}-"0"${toMonth}-30T23:59:59`
          // );
        }
        store.dispatch("Rawdata/setmonthSelectionPayloadStateAction", {
          added_to_database: finalpayloaddate,
        });

        // console.log(new Date(e).getFullYear());
        // let status = store.getters["Rawdata/getUserSearchDateGetters"];
        // if (
        //   monthSelectionFrom.value !== null ||
        //   monthSelectionFrom.value !== "None" ||
        //   monthSelectionTo.value !== null ||
        //   monthSelectionTo.value !== "None" ||
        //   monthSelectionTo.value !== "Select Month" ||
        //   monthSelectionFrom.value !== "Select Month"
        // ) {
        //   alert(1);
        //   searchDateBoxFlag.value = true;
        // } else {
        //   searchDateBoxFlag.value = false;
        // }
      }
      // console.log(monthSelectionFrom.value, "sss");
      // console.log(searchDateBoxFlag.value, "sss");
    }
    function clear() {
      VueCookies.remove("callLastResult");
      VueCookies.remove("callLastResult");
      window.location.reload();
      // clearAllFlag.value = true;
      // window.open("http://localhost:8081/", "_blank");
      // window.open("http://localhost:8080", "_blank");
    }

    function tofuncManual(tt) {
      // console.log(tt, "tt");
      // console.log(firstdate.value, "sec");
      firstdate.value == "";
      let date = moment(tt).format("YYYY-MM-DD");
      // console.log(date, "fromdate");
      if (moment(date, "YYYY-MM-DD", true).isValid()) {
        firstdate.value = date;
        frommenu.value = false;
      }
    }
    function fromfunc(a) {
      // firstdate.value == "";
      let date = moment(a).format("YYYY-MM-DD");
      // console.log(date, "fromdate");
      if (moment(date, "YYYY-MM-DD", true).isValid()) {
        firstdate.value = date;
        frommenu.value = false;
      }
      store.dispatch("Rawdata/setfromDateAction", firstdate.value);
    }
    function tofunc(a) {
      // seconddate.value == "";
      let date = moment(a).format("YYYY-MM-DD");
      // console.log(date, "d11ate");
      if (moment(date, "YYYY-MM-DD", true).isValid()) {
        seconddate.value = date;
        tomenu.value = false;
      }
      store.dispatch("Rawdata/settoDateAction", seconddate.value);
    }
    // function save_date() {
    //   // menu.value = false;
    //   // send_date.value = datepick.value;
    //   let betweenTime = store.getters["Rawdata/getbetweenTimePayloadGetters"];
    //   let andTime = store.getters["Rawdata/getAndTimePayloadGetters"];
    //   const options = { day: "2-digit", month: "2-digit", year: "numeric" };
    //   if (datepick.value.length < 2) {
    //     date.value =
    //       "From " + datepick.value[0].toLocaleDateString("en-GB", options);
    //   } else {
    //     date.value =
    //       "From " +
    //       datepick.value[0].toLocaleDateString("en-GB", options) +
    //       " To " +
    //       datepick.value[1].toLocaleDateString("en-GB", options);
    //   }
    //   // console.log(betweenTime, 88);
    //   // console.log(new Date(datepick.value[0]).getMonth());
    //   // let from = new Date(datepick.value[0]);
    //   // console.log(new Date(datepick.value[1]).getMonth());
    //   // let to = new Date(datepick.value[1]);
    //   // let datesplit = date.value.split(" ");
    //   // console.log("f", from);
    //   // console.log("t", to);
    //   let fromDate = new Date(datepick.value[0]).getDate();
    //   let fromMonth = new Date(datepick.value[0]).getMonth() + 1;
    //   let fromYear = new Date(datepick.value[0]).getFullYear();
    //   let toDate = new Date(datepick.value[1]).getDate();
    //   let toMonth = new Date(datepick.value[1]).getMonth() + 1;
    //   let toYear = new Date(datepick.value[1]).getFullYear();

    //   if (datepick.value.length == 2) {
    //     // console.log(fromDate, "fromDate");
    //     store.dispatch("Rawdata/setfromDateAction", fromDate);
    //     // console.log(fromMonth, "fromMonth");
    //     store.dispatch("Rawdata/setfromMonthAction", fromMonth);
    //     // console.log(fromYear, "fromYear");
    //     store.dispatch("Rawdata/setfromYearAction", fromYear);
    //     // console.log(toDate, "toDate");
    //     store.dispatch("Rawdata/settoDateAction", toDate);
    //     // console.log(toMonth, "toMonth");
    //     store.dispatch("Rawdata/settoMonthAction", toMonth);
    //     // console.log(toYear, "toYear");
    //     store.dispatch("Rawdata/settoYearAction", toYear);
    //     finalApprovedDate.value = `S${fromYear}-${fromMonth}-${fromDate}T${fromTime.value}E${toYear}-${toMonth}-${toDate}T${ToTime.value}`;
    //     console.log(finalApprovedDate.value);
    //   }

    //   if (betweenTime || andTime) {
    //     finalApprovedDate.value = `S${fromYear}-${fromMonth}-${fromDate}T${
    //       betweenTime ? betweenTime : fromTime.value
    //     }E${toYear}-${toMonth}-${toDate}T${andTime ? andTime : ToTime.value}`;
    //   }
    // }

    function searchDateHandler(e) {
      // console.log(e);
      // console.log(selectedDate, "selectedDate");
      // console.log(selectedDate.value, 90);
      // if (selectedDate.value == "None" || selectedDate.value == null) {
      //   store.dispatch("Rawdata/setUserSearchDate", null);
      //   monthBoxFlag.value = false;
      // } else {
      //   store.dispatch("Rawdata/setUserSearchDate", selectedDate.value);
      //   monthBoxFlag.value = true;
      // }
      if (e !== "Select Period") {
        let curdate = new Date();
        let pastdate = new Date();
        let curyear = curdate.getFullYear();
        let curmonth1 = `${curdate.getMonth() + 1}`;
        let curmonth2 = curmonth1 <= 9 ? `0${curmonth1}` : curmonth1;
        let curDate = curdate.getDate();
        let curdate1 = curDate <= 9 ? `0${curDate}` : curDate;
        let finalDate = "";
        if (e == "1week") {
          pastdate.setDate(pastdate.getDate() - 7);
          let pastyear = pastdate.getFullYear();
          let pastmonth = `${pastdate.getMonth() + 1}`;
          let pastMonth1 = pastmonth <= 9 ? `0${pastmonth}` : pastmonth;
          monthBoxFlag.value = false;
          let pastDate = pastdate.getDate();
          let pastDate1 = pastDate <= 9 ? `0${pastDate}` : pastDate;
          // console.log(pastDate1, "dt");
          finalDate = `S${pastyear}-${pastMonth1}-${pastDate1}T00:00:00E${curyear}-${curmonth2}-${curdate1}T23:59:59`;
        } else if (e == "2week") {
          pastdate.setDate(pastdate.getDate() - 14);
          let pastyear = pastdate.getFullYear();
          monthBoxFlag.value = false;
          let pastmonth = `${pastdate.getMonth() + 1}`;
          let pastMonth1 = pastmonth <= 9 ? `0${pastmonth}` : pastmonth;
          let pastDate = pastdate.getDate();
          let pastDate1 = pastDate <= 9 ? `0${pastDate}` : pastDate;
          finalDate = `S${pastyear}-${pastMonth1}-${pastDate1}T00:00:00E${curyear}-${curmonth2}-${curdate1}T23:59:59`;
        } else if (e == "1month") {
          pastdate.setDate(pastdate.getDate() - 30);
          let pastyear = pastdate.getFullYear();
          monthBoxFlag.value = false;
          let pastmonth = `${pastdate.getMonth() + 1}`;
          let pastMonth1 = pastmonth <= 9 ? `0${pastmonth}` : pastmonth;
          let pastDate = pastdate.getDate();
          let pastDate1 = pastDate <= 9 ? `0${pastDate}` : pastDate;
          finalDate = `S${pastyear}-${pastMonth1}-${pastDate1}T00:00:00E${curyear}-${curmonth2}-${curdate1}T23:59:59`;
        } else if (e == "3month") {
          pastdate.setDate(pastdate.getDate() - 90);
          let pastyear = pastdate.getFullYear();
          monthBoxFlag.value = false;
          let pastmonth = `${pastdate.getMonth() + 1}`;
          let pastMonth1 = pastmonth <= 9 ? `0${pastmonth}` : pastmonth;
          let pastDate = pastdate.getDate();
          let pastDate1 = pastDate <= 9 ? `0${pastDate}` : pastDate;
          finalDate = `S${pastyear}-${pastMonth1}-${pastDate1}T00:00:00E${curyear}-${curmonth2}-${curdate1}T23:59:59`;
        } else if (e == "6month") {
          pastdate.setDate(pastdate.getDate() - 180);
          let pastyear = pastdate.getFullYear();
          let pastmonth = `${pastdate.getMonth() + 1}`;
          let pastMonth1 = pastmonth <= 9 ? `0${pastmonth}` : pastmonth;
          let pastDate = pastdate.getDate();
          let pastDate1 = pastDate <= 9 ? `0${pastDate}` : pastDate;
          monthBoxFlag.value = false;
          finalDate = `S${pastyear}-${pastMonth1}-${pastDate1}T00:00:00E${curyear}-${curmonth2}-${curdate1}T23:59:59`;
        } else if (e == "1year") {
          pastdate.setDate(pastdate.getDate() - 365);
          let pastyear = pastdate.getFullYear();
          let pastmonth = `${pastdate.getMonth() + 1}`;
          let pastMonth1 = pastmonth <= 9 ? `0${pastmonth}` : pastmonth;
          let pastDate = pastdate.getDate();
          let pastDate1 = pastDate <= 9 ? `0${pastDate}` : pastDate;
          monthBoxFlag.value = false;
          finalDate = `S${pastyear}-${pastMonth1}-${pastDate1}T00:00:00E${curyear}-${curmonth2}-${curdate1}T23:59:59`;
        } else {
          monthBoxFlag.value = true;
        }
        // console.log(finalDate, "finalDate");
        store.dispatch("Rawdata/setsearchDatePayloadAction", finalDate);
      } else {
        monthBoxFlag.value = true;
        store.dispatch("Rawdata/setsearchDatePayloadAction", "");
      }
      // let dtFindSt = store.getters["Rawdata/getUserMonthGetters"].length;
      // console.log(dtFindSt, "dt")
      // return dtFindSt > 0 ? false : false;
    }

    function productNameOpen() {
      return store.getters["Sector/getCreditComboBoxesGetters"];
    }
    // console.log(store().getters["Rawdata/getDrawer"]);
    const extended_search = computed({
      get() {
        return store.getters["Rawdata/getExtendedSearch"];
      },
      set(val) {
        store.dispatch("Rawdata/setExtendedSearch", val);
      },
    });
    const drawer = computed({
      get() {
        return store.getters["Rawdata/getDrawer"];
      },
      set(val) {
        // console.log(val);
        store.dispatch("Rawdata/setDrawer", val);
      },
    });
    const show_checkbox = computed({
      get() {
        let val = store.getters["mics/get_exact"];
        return val;
      },
      set(val) {
        if (val === false) {
          exactCheckbox.value = false;
        }
        store.dispatch("mics/set_exact", val);
      },
    });
    // function convertTo24HourFormat(time12Hour) {
    //   const [time, period] = time12Hour.split(" ");

    //   let [hours, minutes] = time.split(":");
    //   hours = parseInt(hours, 10);
    //   minutes = parseInt(minutes, 10);

    //   if (period === "PM" && hours !== 12) {
    //     hours += 12;
    //   } else if (period === "AM" && hours === 12) {
    //     hours = 0;
    //   }

    //   return `${hours.toString().padStart(2, "0")}:${minutes
    //     .toString()
    //     .padStart(2, "0")}`;
    // }

    // const time12Hour = "12:45 AM";
    // const time24Hour = convertTo24HourFormat(time12Hour);
    // console.log(time24Hour); // Output: '00:45'

    function removeCompany(c) {
      console.log(c);
      choosenCompanies.value = choosenCompanies.value.filter(
        (o) => c.id !== o.id
      );
      store.dispatch("Rawdata/setCompanyDataAction", choosenCompanies.value);
      const multiPay = {
        event: "Company",
        value: choosenCompanies.value,
      };
      store.dispatch("Rawdata/setSearchCriteriaMultiTextboxes", multiPay);
      if (companies.value.length > 0) {
        companies.value.unshift(c);
      }
    }

    function addRewardSearchCriteria(e) {
      // console.log("Event", e);
      let searchCiteria = store.getters["Rawdata/getSearchCriteria"];
      if (e.target.checked) {
        Object.assign(searchCiteria, {
          Related: "Related",
        });
      } else {
        delete searchCiteria["Related"];
      }
    }

    function removeProduct(c) {
      choosenProduct.value = choosenProduct.value.filter((o) => c.id !== o.id);

      store.dispatch("Rawdata/setProductNamesDataAction", choosenProduct.value);
      const multiPay = {
        event: "Product Name",
        value: choosenProduct.value,
      };
      store.dispatch("Rawdata/setSearchCriteriaMultiTextboxes", multiPay);
      if (products.value.length > 0) {
        products.value.unshift(c);
      }
    }

    function removeAffinity(c) {
      choosenAffinity.value = choosenAffinity.value.filter(
        (o) => c.id !== o.id
      );
      store.dispatch("Rawdata/setAffinityDataAction", choosenAffinity.value);
      const multiPay = {
        event: "Affinity/Association ",
        value: choosenAffinity.value,
      };
      store.dispatch("Rawdata/setSearchCriteriaMultiTextboxes", multiPay);
      if (affinities.value.length > 0) {
        affinities.value.unshift(c);
      }
    }

    function panelistFnHandler() {
      let searchCiteria = store.getters["Rawdata/getSearchCriteria"];
      if (panelistSelectedModel.value !== "All") {
        if (panelistSelectedModel.value === "primary") {
          Object.assign(searchCiteria, {
            Panelists: "Primary",
          });
        } else {
          Object.assign(searchCiteria, {
            Panelists: "Non",
          });
        }
      } else {
        delete searchCiteria["Panelists"];
      }
      store.dispatch("Rawdata/setPanelistTextAction", panelistId.value);
      store.dispatch(
        "Rawdata/setPanelistRadioAction",
        panelistSelectedModel.value
      );
      // console.log(panelistId.value);
      // console.log(panelistSelectedModel.value);
    }

    function onResize() {
      // console.log(window.innerWidth);
      // console.log(window.innerHeight);
      if (window.innerWidth <= 1024) {
        drawer.value = false;
      } else {
        drawer.value = true;
      }
    }
    function searchHandler() {
      if (VueCookies.get("callLastSearch")) {
        VueCookies.remove("callLastSearch");
      }
      if (VueCookies.get("callLastResult")) {
        VueCookies.remove("callLastResult");
      }
      let approveddatetime = "";
      ("S2023-10-01T00:00:00E2023-10-05T23:59:59");
      let betweenTime = store.getters["Rawdata/getbetweenTimePayloadGetters"];
      let andTime = store.getters["Rawdata/getAndTimePayloadGetters"];
      store.dispatch("Rawdata/setsearchBtnFlag", false);
      // moment("01:15 PM", ["h:mm A"])
      // let firstd = store.getters["Rawdata/getfromDateGetters"];
      // let secondd = store.getters["Rawdata/gettoDateGetters"];
      // console.log(betweenTime, "betweenTime");
      // console.log(andTime, "andTime");
      // console.log(moment(firstdate.value, "YYYY-MM-DD", true).isValid()); //true
      if (
        moment(firstdate.value, "YYYY-MM-DD", true).isValid() &&
        moment(seconddate.value, "YYYY-MM-DD", true).isValid()
      ) {
        approveddatetime = `S${
          firstdate.value ? moment(firstdate.value).format("YYYY-MM-DD") : ""
        }T${betweenTime ? betweenTime : "00:00:00"}E${
          seconddate.value ? moment(seconddate.value).format("YYYY-MM-DD") : ""
        }T${andTime ? andTime : "23:59:00"}`;
        finalApprovedDate.value = approveddatetime;
      } else {
        finalApprovedDate.value = null;
        firstdate.value = null;
        seconddate.value = null;
      }

      let media = store.getters["Rawdata/getmediaAPIPayloadGetters"];
      // console.log(media, "media");
      let sector = store.getters["Rawdata/getsectorAPIPayloadGetters"];
      // console.log(sector, "sector");
      // let sectorToggle = store.getters["Rawdata/getsectorAllGetters"];
      let audience = store.getters["Rawdata/getaudienceAPIPayloadGetters"];
      // console.log(audience, "audience")
      let selectionDate =
        store.getters["Rawdata/getmonthSelectionPayloadStateGetters"];
      let deliveryMethodId = store.getters["Sector/getDeliveryMethodId"];
      let deliveryTypeId = store.getters["Sector/getDeliveryTypeId"];
      let packageTypeId = store.getters["Sector/getPackageTypeId"];
      let presortedId = store.getters["Sector/getPresortedId"];
      let postageId = store.getters["Sector/getPostageId"];

      let defaultDropDownData = store.getters["Sector/getDefaultDropDownData"];
      let checkedPayload = store.getters["Sector/getCheckboxPayload"];
      let checkedTargetIds =
        store.getters["Sector/getCheckboxPayloadtargetIds"];
      let energySetPayload = store.getters["Sector/getEnergySetPayload"];
      let searchDatePayload =
        store.getters["Rawdata/getsearchDatePayloadGetters"];
      let ids = [];
      let siDropDownPayload = store.getters["Sector/getSiDropDownPayload"];
      let offerOrigin = store.getters["Sector/getOfferOrigin"];
      let loamAmount = store.getters["Sector/getLoanAmount"];
      let affinityCategories = store.getters["Sector/getAffinityCategories"];
      let companyData = store.getters["Rawdata/getcompanyDataGetters"];
      let affinityData = store.getters["Rawdata/getaffinityDataGetters"];
      let productData = store.getters["Rawdata/getproductNameDataGetters"];
      let catData = store.getters["Sector/getcategoryPayload"];
      // console.log(affinityCategories, " affinityCategories");
      // console.log(checkedPayload, " api checkedPayload");
      let communicationType =
        store.getters["Rawdata/getcommunicationTypeSelectionGetters"];
      let groupSizes = store.getters["Rawdata/getgroupSizePayloadGetters"];
      let electronicType =
        store.getters["Rawdata/getelectronicTypePayloadGetters"];
      let publicationType =
        store.getters["Rawdata/getPublicationTypePayloadGetters"];
      let personalisedRadio =
        store.getters["Rawdata/getpersonalizedRadiosGetters"];
      let issueType = store.getters["Rawdata/getissueTypePayloadGetters"];
      let networkname = store.getters["Rawdata/getnetworkNamePayloadGetters"];
      let social = store.getters["Rawdata/getsocialPayloadGetters"];
      let introPricing =
        store.getters["Rawdata/getintroductoryPricingPayloadGetters"];
      let ocrpayload = store.getters["Rawdata/getocrFullTextPayloadGetters"];
      // console.log(ocrpayload, "ocrpayload");
      let PublicationNames =
        store.getters["Rawdata/getPublicationNamePayloadGetters"];
      if (monthSelectionTo.value || monthSelectionFrom.value) {
        if (
          monthSelectionFrom.value === "Select Month" &&
          monthSelectionTo.value !== "Select Month"
        ) {
          alert("Select Start Month");
          return;
        } else if (
          monthSelectionTo.value === "Select Month" &&
          monthSelectionFrom.value !== "Select Month"
        ) {
          alert("Select End Month");
          return;
        }
      }
      // console.log(electronicType, "electronicType")
      if (checkedPayload.affinity_association !== "1") {
        delete affinityCategories.affinity_category;
        delete affinityCategories.affinity_sub_category;
      }
      // if (checkedPayload.rewards_program === undefined) {
      //   delete affinityCategories.rewards_program_emphasis;
      //   delete checkedPayload.rewards_program;
      // }
      if (
        checkedPayload.nots0 !== undefined ||
        checkedPayload.nots1 !== undefined
      ) {
        if (checkedPayload.nots0 === undefined) {
          checkedPayload["nots"] = checkedPayload.nots1;
        }
        if (checkedPayload.nots1 === undefined) {
          if (
            siDropDownPayload.agent_communication_id &&
            siDropDownPayload.agent_communication_id.length !== undefined &&
            siDropDownPayload.agent_communication_id.length > 0
          ) {
            checkedPayload["nots"] = "agent_communication_id";
          } else {
            checkedPayload["nots"] = checkedPayload.nots0;
          }
        }
        if (
          checkedPayload.nots0 !== undefined &&
          checkedPayload.nots1 !== undefined
        ) {
          if (
            siDropDownPayload.agent_communication_id &&
            siDropDownPayload.agent_communication_id.length !== undefined &&
            siDropDownPayload.agent_communication_id.length > 0
          ) {
            checkedPayload["nots"] = "mtype_id,agent_communication_id";
          } else {
            checkedPayload["nots"] =
              checkedPayload.nots1 + "," + checkedPayload.nots0;
          }
        }
      } else {
        delete checkedPayload.nots;
      }
      if (checkedPayload.target_market_id !== undefined) {
        if (checkedTargetIds.length > 0) {
          for (let i = 0; i < checkedTargetIds.length; i++) {
            ids.push(checkedTargetIds[i]);
          }
          checkedPayload["target_market_id"] = ids.toString();
          delete checkedPayload.null_search;
        } else {
          checkedPayload["target_market_id"] = "1";
          checkedPayload["null_search"] = "target_market_id,notnull";
        }
      } else {
        delete checkedPayload.target_market_id;
        delete checkedPayload.null_search;
      }

      if (ORandInputModel.value && ORandInputModel.value !== undefined) {
        if (
          ORandInputModel.value.indexOf('"') >= 0 ||
          ORandInputModel.value.indexOf("'") >= 0
        ) {
          delete ocrpayload["text_match_op"];
        }
      }

      if (ocrpayload["product_headline"] !== undefined && toggleOCRFlag.value) {
        // console.log("EWS..", ocrpayload["product_headline"].length);
        if (ocrpayload["product_headline"].length === 0) {
          delete ocrpayload.product_headline;
        }
      }
      if (ocrpayload["dts_val"] !== undefined && toggleOCRFlag.value) {
        if (ocrpayload["dts_val"].length === 0) {
          delete ocrpayload.dts_val;
        }
      }

      if (
        (FullInputModel.value === undefined ||
          FullInputModel.value === null ||
          FullInputModel.value.length === 0) &&
        (fullTextOCRModel.value !== "fulltext2" || !toggleOCRFlag.value)
      ) {
        delete ocrpayload.product_headline;
      }
      if (
        (ORandInputModel.value === undefined ||
          ORandInputModel.value === null ||
          ORandInputModel.value.length === 0) &&
        (fullTextOCRModel.value !== "fulltext2" || !toggleOCRFlag.value)
      ) {
        delete ocrpayload.dts_val;
      }
      console.log(media, sector, audience, "aaaa");
      if (
        (media.length > 0 && sector.length > 0 && audience.length > 0) ||
        ocrpayload.product_headline !== undefined ||
        ocrpayload.dts_val !== undefined
      ) {
        resultWidthValue.value = "80%";
        // drawer.value = false;
        let apidata = {
          sortby: "entry_id_sort, desc",
          tiebreaker: "product_id, desc",
          product_status: "1",
          page_type: 1,
          mchanne_id: [],
          sector_id: [],
          mpanel_id: [],
        };
        let newCheckedPayload = null;
        newCheckedPayload = { ...newCheckedPayload, ...checkedPayload };
        delete newCheckedPayload.nots0;
        delete newCheckedPayload.nots1;
        apidata = { ...apidata, ...newCheckedPayload };
        apidata = { ...apidata, ...energySetPayload };
        apidata = { ...apidata, ...siDropDownPayload };
        apidata = { ...apidata, ...affinityCategories };
        apidata = { ...apidata, ...defaultDropDownData };
        if (media) {
          Object.keys(apidata).find((key) => {
            // console.log(key);
            if (key === "mchanne_id")
              media.forEach((m) => apidata[key].push(m));
          });
        }
        if (
          selectionDate &&
          selectionDate.added_to_database &&
          selectionDate.added_to_database.length > 0
        ) {
          apidata = { ...apidata, ...selectionDate };
        } else if (searchDatePayload.length > 0) {
          Object.assign(apidata, { added_to_database: searchDatePayload });
        }

        if (media.length === 0) {
          delete apidata["mchanne_id"];
        }
        if (sector) {
          Object.keys(apidata).find((key) => {
            // console.log(key);
            if (key === "sector_id")
              sector.forEach((s) => apidata[key].push(s));
          });
        }
        if (sector.length === 0) {
          delete apidata["sector_id"];
        }
        if (audience) {
          Object.keys(apidata).find((key) => {
            // console.log(key);
            if (key === "mpanel_id")
              audience.forEach((a) => apidata[key].push(a));
          });
        }
        if (audience.length === 0) {
          delete apidata["mpanel_id"];
        }
        // let apidata2 = JSON.parse(JSON.stringify(apidata));
        Object.keys(apidata).forEach((key) => {
          if (
            key === "mpanel_id" ||
            key === "sector_id" ||
            key === "mchanne_id"
          ) {
            apidata[key] = apidata[key].join(",");
            // console.log(23, apidata[key].join(","));
            // console.log(apidata);
          }
        });

        if (deliveryMethodId.length > 0) {
          apidata["delivery_method_id"] = deliveryMethodId.toString();
          if (
            deliveryMethodId.includes(1) ||
            deliveryMethodId.includes(3) ||
            deliveryMethodId.includes(7)
          ) {
            if (deliveryTypeId.length > 0) {
              apidata["delivery_type_id"] = deliveryTypeId.toString();
            } else {
              delete apidata.delivery_type_id;
            }
            if (packageTypeId.length > 0) {
              apidata["package_type_id"] = packageTypeId.toString();
            } else {
              delete apidata.package_type_id;
            }
            if (presortedId.length > 0) {
              apidata["presorted_id"] = presortedId.toString();
            } else {
              delete apidata.presorted_id;
            }
            if (postageId.length > 0) {
              apidata["postage_id"] = postageId.toString();
            } else {
              delete apidata.postage_id;
            }
          }
        } else {
          delete apidata.delivery_method_id;
          delete apidata.package_type_id;
          delete apidata.presorted_id;
          delete apidata.postage_id;
          delete apidata.delivery_type_id;
        }
        if (store.getters["mics/get_exact"]) {
          if (exactCheckbox.value) {
            apidata["multi_match_op"] = "sector_id,exact";
          } else {
            apidata["multi_match_op"] = "sector_id,only";
          }
        } else {
          delete apidata.multi_match_op;
        }
        if (loamAmount.changeHappen) {
          apidata["minimum_loan_amount"] = loamAmount.min.toString();
          apidata["maximum_loan_amount"] = "0," + loamAmount.max.toString();
          apidata["offered_loan_amount"] =
            loamAmount.min.toString() + "," + loamAmount.max.toString();
          apidata["range_search"] =
            "minimum_loan_amount, maximum_loan_amount,offered_loan_amount;rel: (minimum_loan_amount,maximum_loan_amount)|(offered_loan_amount)";
        } else {
          delete apidata.minimum_loan_amount;
          delete apidata.maximum_loan_amount;
          delete apidata.offered_loan_amount;
          if (energySetPayload.range_search === undefined) {
            delete apidata.range_search;
          }
        }
        let com = [];
        companyData.forEach((i) => com.push(i.id));
        // console.log("com", com);
        let comstr = com.toString();
        let aff = [];
        // console.log(affinityData, "affinityData");
        affinityData.forEach((i) => aff.push(i.id));
        let affstr = aff.toString();
        let prod = [];
        productData.forEach((i) => prod.push(`\"${i.productName}\"`));
        let prodstr = prod.toString();
        if (comstr) {
          Object.assign(apidata, { company_id: comstr });
        }
        if (affstr) {
          Object.assign(apidata, { afinity_id: affstr });
        }
        if (prodstr) {
          Object.assign(apidata, {
            product_name: prodstr,
          });
        }

        let introPayload = {};
        introPayload = { null_search: [] };

        introPricing.forEach((i) => {
          if (i === 1) {
            introPayload = {
              ...introPayload,
              purchase_introductory_apr: i.toString(),
            };
            Object.keys(introPayload).find((key) => {
              if (key === "null_search") {
                introPayload[key].push("purchase_introductory_apr,notnull");
              }
            });
          }
          if (i === 2) {
            introPayload = {
              ...introPayload,
              balance_transfer_introductory_apr: "1",
            };
            Object.keys(introPayload).find((key) => {
              if (key === "null_search") {
                introPayload[key].push(
                  "balance_transfer_introductory_apr,notnull"
                );
              }
            });
          }
          if (i === 3) {
            introPayload = {
              ...introPayload,
              purchase_introductory_apr: "1",
            };
            Object.keys(introPayload).find((key) => {
              if (key === "null_search") {
                introPayload[key].push("purchase_introductory_apr,null");
              }
            });
          }
          if (i === 4) {
            introPayload = {
              ...introPayload,
              balance_transfer_introductory_apr: "1",
            };
            Object.keys(introPayload).find((key) => {
              if (key === "null_search") {
                introPayload[key].push(
                  "balance_transfer_introductory_apr,null"
                );
              }
            });
          }
        });
        // }
        Object.keys(introPayload).find((key) => {
          if (key === "null_search") {
            introPayload[key] = introPayload[key].join(";");
          }
          if (introPayload.null_search.length !== 0) {
            Object.assign(apidata, {
              ...introPayload,
            });
          }
        });
        // console.log("introPricing", introPayload);

        if (Object.keys(ocrpayload).length > 0) {
          Object.assign(apidata, {
            ...ocrpayload,
          });
        }

        if (groupSizes !== undefined && groupSizes !== null) {
          if (groupSizes.length > 0) {
            const valuesArray = Object.entries(groupSizes).map(
              (obj) => Object.values(obj)[1]
            );

            const resultString = valuesArray.join(",");

            // console.log("resultString", resultString);
            Object.assign(apidata, {
              group_size_id: resultString,
            });
          }
        }

        if (electronicType.length > 0) {
          const valuesArray = Object.entries(electronicType).map(
            (obj) => Object.values(obj)[1]
          );

          const resultString = valuesArray.join(",");

          // console.log("resultString", resultString);
          Object.assign(apidata, {
            electronic_id: resultString,
          });
        }

        // console.log(finalApprovedDate.value, "finalApprovedDate");
        let validFirstDate = !isNaN(new Date(firstdate.value));
        let validSecondDate = !isNaN(new Date(seconddate.value));
        if (
          finalApprovedDate.value &&
          firstdate.value &&
          seconddate.value &&
          validFirstDate &&
          validSecondDate
        ) {
          Object.assign(apidata, {
            approved_date: finalApprovedDate.value,
          });
        }

        // publication type

        if (publicationType !== undefined && publicationType !== null) {
          if (publicationType.length > 0) {
            const valuesArray = Object.entries(publicationType).map(
              (obj) => Object.values(obj)[1]
            );
            const resultString = valuesArray.join(",");
            Object.assign(apidata, {
              publication_type_id: resultString,
            });
          }
        }

        if (PublicationNames !== undefined && PublicationNames !== null) {
          if (PublicationNames.length > 0) {
            const valuesArray = Object.entries(PublicationNames).map(
              (obj) => Object.values(obj)[1]
            );
            const resultString = valuesArray.join(",");
            Object.assign(apidata, {
              publication_id: resultString,
            });
          }
        }

        if (issueType !== null && issueType !== undefined) {
          const valuesArray = Object.entries(issueType).map(
            (obj) => Object.values(obj)[1]
          );
          const resultString = valuesArray.join(",");
          // console.log("resultString", resultString);
          Object.assign(apidata, {
            issue_type_id: resultString,
          });
        }

        // console.log("panelistID", panelistId);
        if (panelistId.value !== null && panelistId.value !== undefined) {
          if (panelistId.value.length !== 0) {
            Object.assign(apidata, {
              competi_id: panelistId.value,
            });
          }
        }

        if (
          panelistSelectedModel.value !== null &&
          panelistSelectedModel.value !== undefined &&
          panelistId.value &&
          panelistSelectedModel.value !== "All"
        ) {
          Object.assign(apidata, {
            competi_id_filter: panelistSelectedModel.value,
          });
        }
        // console.log("personalisedRadio", personalisedRadio);

        if (personalisedRadio !== null && personalisedRadio !== undefined) {
          Object.assign(apidata, {
            personalization: personalisedRadio,
          });
        }

        if (networkname) {
          Object.assign(apidata, {
            external_link: networkname,
          });
        }
        if (social !== null && social !== undefined && social !== 0) {
          Object.assign(apidata, {
            socialmedia_adtype: social.toString(),
          });
        }

        if (
          countrySelectedModel.value !== undefined &&
          countrySelectedModel.value != "All"
        ) {
          Object.assign(apidata, {
            country: countrySelectedModel.value,
          });
        }
        let catExistenceFlag = false;
        // console.log(catData, "catData");
        let catDataCopied = JSON.parse(JSON.stringify(catData));
        if (Object.keys(catDataCopied).length > 0 && typeof Object) {
          Object.keys(catDataCopied).find((key) => {
            if (key == "cat_") {
              if (catDataCopied[key].length > 0) {
                catExistenceFlag = true;
                catDataCopied[key] = catDataCopied[key]?.join(",").toString();
              }

              // console.log(catDataCopied[key].length, "len");
            } else if (key == "cat_sub") {
              if (catDataCopied[key].length > 0) {
                catDataCopied[key] = catDataCopied[key]?.join(",").toString();
              }
            } else if (key == "cat_ssub") {
              if (catDataCopied[key].length > 0) {
                catDataCopied[key] = catDataCopied[key]?.join(",").toString();
              }
            }
            // let cat1 = catDataCopied["categories"];
            let cat2 = catDataCopied["cat_"];
            let cat3 = catDataCopied["cat_sub"];
            let cat4 = catDataCopied["cat_ssub"];
            // console.log(cat2, "cat2");
            // console.log(cat3, "cat3");
            // console.log(cat4, "cat4");
            if (catExistenceFlag) {
              // let categories = `field:sector_id;cat_:${cat2};cat_sub:${cat3};cat_ssub:${cat4}`;
              let categories = `field:sector_id;cat_:${cat2}`;
              if (cat3.length > 0) {
                categories = categories + ";" + `cat_sub:${cat3}`;
              }
              if (cat4.length > 0) {
                categories = categories + ";" + `cat_ssub:${cat4}`;
              }
              // let categories = `field:sector_id;cat_:${cat2};cat_sub:${cat3};cat_ssub:${cat4}`;
              apidata = { ...apidata, categories: categories };
            }
          });
        }
        isLoading.value = true;
        store.dispatch("Rawdata/setsearchedBodyDataAction", apidata);
        console.log("api", apidata);
        searchAPIHit(apidata);
        store.dispatch("Rawdata/setActionPayload", apidata);
      } else {
        alert("Select media, sector and audience");
      }
    }
    function searchAPIHit(apidata) {
      // const bodyPayload = store.getters["Rawdata/getsearchAPIBodyGetters"];
      console.log(apidata, "pay");
      // console.log(bodyPayload, "bodyPayload");
      store.dispatch("Rawdata/setSearchAgainFlag", true);
      let searchCiteria = store.getters["Rawdata/getSearchCriteria"];
      if (apidata["mchanne_id"] === undefined) {
        delete searchCiteria["Media Channel"];
      }
      if (apidata["dts_val"] !== undefined) {
        const searchCry = {
          val: ORandInputModel.value,
          column: "ocr",
        };
        store.dispatch("Rawdata/setSearchCritertia", searchCry);
      } else {
        delete searchCiteria["ocr"];
      }
      if (apidata["product_headline"] !== undefined) {
        const searchCry = {
          val: apidata["product_headline"],
          column: "full",
        };
        store.dispatch("Rawdata/setSearchCritertia", searchCry);
      } else {
        delete searchCiteria["full"];
      }
      if (apidata["sector_id"] === undefined) {
        delete searchCiteria["Sectors"];
      }
      if (apidata["mpanel_id"] === undefined) {
        delete searchCiteria["Audience"];
      }
      if (apidata["application_type"] === undefined) {
        delete searchCiteria["Application Type"];
      }
      if (apidata["issue_type_id"] === undefined) {
        delete searchCiteria["Issue Type"];
      }
      if (apidata["mtype_id"] === undefined) {
        delete searchCiteria["Mailing Type"];
      }
      if (apidata["business_content"] === undefined) {
        delete searchCiteria["Business Content"];
      }
      if (apidata["age_id"] === undefined) {
        delete searchCiteria["Age"];
      }
      if (apidata["income_id"] === undefined) {
        delete searchCiteria["Income"];
      }
      if (apidata["fico_range_id"] === undefined) {
        delete searchCiteria["FicoScore"];
      }
      if (apidata["creditvision_range_id"] === undefined) {
        delete searchCiteria["CreditVision"];
      }
      if (apidata["vantage_range_id"] === undefined) {
        delete searchCiteria["VantageScore"];
      }
      if (apidata["ancillary_product_id"] === undefined) {
        delete searchCiteria["Ancillary Products"];
      }
      if (apidata["state_id"] === undefined) {
        delete searchCiteria["State/Province"];
      }
      if (apidata["group_size_id"] === undefined) {
        delete searchCiteria["Group Size"];
      }
      if (apidata["electronic_id"] === undefined) {
        delete searchCiteria["Electronic Type"];
      }
      if (apidata["publication_type_id"] === undefined) {
        delete searchCiteria["Publication Type"];
      }
      if (apidata["card_network"] === undefined) {
        delete searchCiteria["Card Network"];
      }
      if (apidata["response_mechanism_id"] === undefined) {
        delete searchCiteria["Response Mechanism"];
      }
      if (apidata["edc_id"] === undefined) {
        delete searchCiteria["EDC / LDC / TDSP"];
      }
      if (apidata["e_rate_type"] === undefined) {
        delete searchCiteria["Energy - Rate Type"];
      }
      if (apidata["e_offer_price"] === undefined) {
        delete searchCiteria["Offer Price (¢ per kWh)"];
      }
      if (apidata["e_term_length"] === undefined) {
        delete searchCiteria["Energy - Term Length"];
      }
      if (apidata["agent_communication_id"] === undefined) {
        delete searchCiteria["Communication Type"];
      }
      if (apidata["dma_code"] === undefined) {
        delete searchCiteria["DMA®"];
      }
      if (apidata["income_producing_assets_segment_code"] === undefined) {
        delete searchCiteria["Income Producing Assets Segment Code *R*"];
      }
      if (apidata["valuescore_for_household"] === undefined) {
        delete searchCiteria["Value Score"];
      }
      if (apidata["face_id"] === undefined) {
        delete searchCiteria["Face Amount"];
      }
      if (apidata["term_id"] === undefined) {
        delete searchCiteria["Term Length"];
      }
      if (apidata["rider_id"] === undefined) {
        delete searchCiteria["Riders"];
      }
      if (apidata["delivery_method_id"] === undefined) {
        delete searchCiteria["Delivery Method"];
      }
      if (apidata["package_type_id"] === undefined) {
        delete searchCiteria["Postage Type"];
      }
      if (apidata["postage_id"] === undefined) {
        delete searchCiteria["Postage"];
      }
      if (apidata["presorted_id"] === undefined) {
        delete searchCiteria["Pre-Sorted"];
      }
      if (apidata["delivery_type_id"] === undefined) {
        delete searchCiteria["Delivery Type"];
      }
      if (apidata["rewards_program_emphasis"] === undefined) {
        delete searchCiteria["Rewards Program Emphasis"];
      }
      if (apidata["affinity_category"] === undefined) {
        delete searchCiteria["Affinity/Association Category"];
      }
      if (apidata["affinity_sub_category"] === undefined) {
        delete searchCiteria["Affinity/Association Sub-Category"];
      }
      if (apidata["offer_origin_id"] === undefined) {
        delete searchCiteria["Offer Origin"];
      }
      if (apidata["language_id"] === undefined) {
        delete searchCiteria["Campaign Language"];
      }
      if (apidata["external_link"] === undefined) {
        delete searchCiteria["Network Name"];
      }
      if (apidata["socialmedia_adtype"] === undefined) {
        delete searchCiteria["Social Media Ad Type"];
      }
      if (apidata["company_id"] === undefined) {
        delete searchCiteria["Company"];
      }
      if (apidata["afinity_id"] === undefined) {
        delete searchCiteria["Affinity/Association "];
      }
      if (apidata["publication_id"] === undefined) {
        delete searchCiteria["Publication Name"];
      }
      if (
        apidata["balance_transfer_introductory_apr"] === undefined &&
        apidata["purchase_introductory_apr"] === undefined
      ) {
        delete searchCiteria["Introductory Pricing"];
      }
      if (apidata["worksite_voluntary"] !== undefined) {
        if (apidata["worksite_voluntary"] !== "0") {
          Object.assign(searchCiteria, {
            "Worksite/Voluntary": "Worksite/Voluntary",
          });
        } else {
          Object.assign(searchCiteria, {
            "Worksite/Voluntary": "Non-Worksite/Voluntary",
          });
        }
      } else {
        delete searchCiteria["Worksite/Voluntary"];
      }
      if (apidata["is_credit_union"] !== undefined) {
        if (apidata["is_credit_union"] !== "0") {
          Object.assign(searchCiteria, {
            "Credit Union": "Credit Union",
          });
        } else {
          Object.assign(searchCiteria, {
            "Credit Union": "Non-Credit Union",
          });
        }
      } else {
        delete searchCiteria["Credit Union"];
      }
      if (apidata["affinity_association"] !== undefined) {
        if (apidata["affinity_association"] !== "0") {
          Object.assign(searchCiteria, {
            "Affinity/Association": "Affinity/Association",
          });
        } else {
          Object.assign(searchCiteria, {
            "Affinity/Association": "Non-Affinity/Association",
          });
        }
      } else {
        delete searchCiteria["Affinity/Association"];
      }
      if (apidata["is_incentive"] !== undefined) {
        if (apidata["is_incentive"] === "1") {
          Object.assign(searchCiteria, {
            Incentive: "Incentive",
          });
        }
      } else {
        delete searchCiteria["Incentive"];
      }
      if (apidata["prescription"] !== undefined) {
        if (apidata["prescription"] === "1") {
          Object.assign(searchCiteria, {
            Rx: "Rx",
          });
        }
      } else {
        delete searchCiteria["Rx"];
      }
      if (apidata["is_affinion"] !== undefined) {
        if (apidata["is_affinion"] === "1") {
          Object.assign(searchCiteria, {
            Affinion: "Affinion",
          });
        }
      } else {
        delete searchCiteria["Affinion"];
      }
      if (apidata["is_prescreen"] !== undefined) {
        if (apidata["is_prescreen"] === "1") {
          Object.assign(searchCiteria, {
            "Pre-Screen/Opt-Out": "Pre-Screen/Opt-Out",
          });
        } else {
          Object.assign(searchCiteria, {
            "Pre-Screen/Opt-Out": "Non-Pre-Screen/Opt-Out",
          });
        }
      } else {
        delete searchCiteria["Pre-Screen/Opt-Out"];
      }
      if (apidata["is_citi"] !== undefined) {
        if (apidata["is_citi"] === "1") {
          Object.assign(searchCiteria, {
            "Retail Card Study": "Retail Card Study",
          });
        } else {
          Object.assign(searchCiteria, {
            "Retail Card Study": "Non-Retail Card Study",
          });
        }
      } else {
        delete searchCiteria["Retail Card Study"];
      }
      if (apidata["target_market_id"] !== undefined) {
        if (apidata["target_market_id"] === "1") {
          Object.assign(searchCiteria, {
            "Target Markets": "Target Markets",
          });
        } else {
          Object.assign(searchCiteria, {
            "Target Markets": searchCiteria["Target Markets"],
          });
        }
      } else {
        delete searchCiteria["Target Markets"];
      }
      if (apidata["Fee_Product"] !== undefined) {
        if (apidata["Fee_Product"] === "1") {
          Object.assign(searchCiteria, {
            "Fee Product": "Fee Product",
          });
        } else {
          Object.assign(searchCiteria, {
            "Fee Product": "Ancillary Service - No Fee",
          });
        }
      } else {
        delete searchCiteria["Fee Product"];
      }
      if (apidata["faux_check"] !== undefined) {
        if (apidata["faux_check"] === "1") {
          Object.assign(searchCiteria, {
            "Faux Check": "Faux Check",
          });
        }
      } else {
        delete searchCiteria["Faux Check"];
      }
      if (apidata["primary_only"] !== undefined) {
        Object.assign(searchCiteria, {
          Primary: "Primary",
        });
      } else {
        delete searchCiteria["Primary"];
      }
      if (apidata["is_reloadable"] !== undefined) {
        Object.assign(searchCiteria, {
          Reloadable: "Reloadable",
        });
      } else {
        delete searchCiteria["Reloadable"];
      }
      if (apidata["rewards_program"] !== undefined) {
        if (apidata["rewards_program"] === "1") {
          Object.assign(searchCiteria, {
            Rewards: "Rewards",
          });
        }
      } else {
        delete searchCiteria["Rewards"];
      }
      if (apidata["is_hphsa"] !== undefined) {
        if (apidata["is_hphsa"] === "1") {
          Object.assign(searchCiteria, {
            "CDHP/HDHP/HSA": "CDHP/HDHP/HSA",
          });
        }
      } else {
        delete searchCiteria["CDHP/HDHP/HSA"];
      }
      if (apidata["r_credit_card_mentioned"] !== undefined) {
        if (apidata["r_credit_card_mentioned"] === "1") {
          Object.assign(searchCiteria, {
            "Credit Card Mentioned": "Credit Card Mentioned",
          });
        }
      } else {
        delete searchCiteria["Credit Card Mentioned"];
      }
      if (
        apidata["jumbo_ncnfg"] !== undefined ||
        apidata["va"] !== undefined ||
        apidata["fha"] !== undefined ||
        apidata["conventional"] !== undefined ||
        apidata["usda"] !== undefined ||
        apidata["correspondent_lending"] !== undefined ||
        apidata["refinance"] !== undefined
      ) {
        const genMortage = [];
        if (apidata["refinance"] !== undefined) {
          if (apidata["Fee_Product"] === "1") {
            genMortage.push("Refinance");
          } else {
            genMortage.push("Non-Refinance");
          }
        }
        if (apidata["jumbo_ncnfg"] !== undefined) {
          genMortage.push("Jumbo/Non-Conforming");
        }
        if (apidata["va"] !== undefined) {
          genMortage.push("VA");
        }
        if (apidata["fha"] !== undefined) {
          genMortage.push("FHA");
        }
        if (apidata["conventional"] !== undefined) {
          genMortage.push("Conventional");
        }
        if (apidata["usda"] !== undefined) {
          genMortage.push("USDA");
        }
        if (apidata["correspondent_lending"] !== undefined) {
          genMortage.push("Correspondent Lending");
        }
        Object.assign(searchCiteria, {
          "General Mortgage & Loan Details": genMortage.toString(),
        });
      } else {
        delete searchCiteria["General Mortgage & Loan Details"];
      }
      if (apidata["e_cancel_fee"] !== undefined) {
        if (apidata["e_cancel_fee"] === "1") {
          Object.assign(searchCiteria, {
            "Cancel Fee": "Cancel Fee",
          });
        }
      } else {
        delete searchCiteria["Cancel Fee"];
      }
      if (apidata["added_to_database"] !== undefined) {
        if (
          monthSelectionFrom.value.length > 0 &&
          monthSelectionTo.value.length > 0 &&
          monthSelectionTo.value !== "Select Month" &&
          monthSelectionFrom.value !== "Select Month"
        ) {
          Object.assign(searchCiteria, {
            "Added to database": `Between ${monthSelectionFrom.value} and ${monthSelectionTo.value}`,
          });
        } else {
          let addToDb = dateData.filter(
            (e) => e.value === selectedDate.value.value
          );
          // console.log(selectedDate.value, "selectedDate.value");
          // console.log(dateData, "dateData");
          Object.assign(searchCiteria, {
            "Added to database": addToDb[0].name,
          });
        }
      } else {
        delete searchCiteria["Added to database"];
      }
      if (apidata["approved_date"] !== undefined) {
        let edate = apidata["approved_date"].substr(21, 10);
        let sdate = apidata["approved_date"].substr(1, 10);
        let startTime = moment(
          apidata["approved_date"].substr(12, 8),
          "HH:mm:ss"
        ).format("hh:mm a");
        let endTime = moment(
          apidata["approved_date"].substr(32, 8),
          "HH:mm:ss"
        ).format("hh:mm a");
        Object.assign(searchCiteria, {
          "Approved Date": `Between ${sdate} ${startTime.toUpperCase()} and ${edate} ${endTime.toUpperCase()}`,
        });
      } else {
        delete searchCiteria["Approved Date"];
      }
      if (apidata["competi_id"] !== undefined) {
        Object.assign(searchCiteria, {
          "Panelist ID": apidata["competi_id"],
        });
      } else {
        delete searchCiteria["Panelist ID"];
      }
      if (apidata["country"] !== undefined) {
        Object.assign(searchCiteria, {
          Country: apidata["country"],
        });
      } else {
        delete searchCiteria["Country"];
      }
      if (apidata["offered_loan_amount"] !== undefined) {
        let amount = apidata["offered_loan_amount"].split(",");

        // console.log("RRRRr", amount[1]);
        Object.assign(searchCiteria, {
          "Minimum Loan Amount ($)": amount[0],
          "Maximum Loan Amount ($)": amount[1],
        });
      } else {
        delete searchCiteria["Minimum Loan Amount ($)"];
        delete searchCiteria["Maximum Loan Amount ($)"];
      }
      if (apidata["personalization"] !== undefined) {
        if (apidata["personalization"] === "1") {
          Object.assign(searchCiteria, {
            Personalization: "Personalized",
          });
        } else {
          Object.assign(searchCiteria, {
            Personalization: "Non-Personalized",
          });
        }
      } else {
        delete searchCiteria["Personalization"];
      }
      // console.log("WWWW", panelistSelectedModel.value);
      // console.log(searchCiteria, "Search Citeria...");
      // console.log(apidata, "apidata");
      fetch("https://elasticsearch-api-uat.competiscan.com/search/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(apidata),
      }).then((response) => {
        response.json().then(async (data) => {
          // sector = await resolveAfter2Seconds();
          isLoading.value = false;
          console.log("2data", data);
          store.dispatch("Rawdata/setsearchResultAction", data);
          window.scrollTo(0, 0);
          saveResult(apidata);
        });
      });
    }
    // async function energyRateTypeFunction(e) {
    //   const energyRat = await store.getters["Sector/getDropDownData"];
    //   console.log("storedata111", energyRat, e);
    //   // { id: 1, value: "Any" }
    //   // energyRateType = energyRat;
    //   // console.log("storedata1111", energyRateType);
    // }
    return {
      // energyRateTypeFunction,
      searchAPIHit,
      // testapi,
      generateTimeIntervals,
      frommenu,
      tomenu,
      firstdate,
      seconddate,
      drawer,
      affinityLookupToggleFlag,
      affinityLookupToggleMsg,
      clearCompanyLookupSelection,
      searchHandler,
      lookupHandler,
      companyLookupToggleMsg,
      show_checkbox,
      menu,
      date,
      datepick,
      fromfunc,
      tofunc,
      // save_date,
      maxdate,
      searchBtnHit,
      extended_search,
      toggleOCRFlag,
      ancillary_product,
      campaign_language,
      usaStatesAPI,
      isLoadingCompany,
      audience,
      productNameOpen,
      sectorsData,
      mediachannel,
      dateData,
      windowSize,
      HandlerEnhancedSearch,
      EnhancedSearchName,
      TimeBtn,
      searchDateUsed,
      clear,
      searchDateHandler,
      countrySelectedModel,
      snackbar,
      selectedDate,
      monthDropdownHandler,
      selectedCompanyNames,
      monthSelectionTo,
      monthSelectionFrom,
      monthBoxFlag,
      searchDateBoxFlag,
      isLoading,
      fullTextOCRModel,
      fullTextOCRInputModel,
      ORandInputModel,
      ORandModel,
      FullInputModel,
      anyOnlyModel,
      exactCheckbox,
      panelistSelectedModel,
      srex0,
      srao0,
      OCRInputFnHandler,
      FullTextInputFnHandler,
      fullTextOCRInputFnHandler,
      finalApprovedDate,
      searchBtnDisabledFlag,
      affinityAPICall,
      timeIntervals,
      monthYearArray,
      companyLookupToggleFlag,
      companyLookupFetch,
      affinitylookupHandler,
      saveResult,
      searchedCompanyName,
      companyLookupName,
      latestCompanySearchQuery,
      selectedCompanyNamesFnHandler,
      clearCompanyLookupUserEntry,
      clearCompanyLookupAllEntry,
      CompanySelectAll,
      CompanyShowAll,
      selectedAffinityNamesFnHandler,
      selectedAffinityNames,
      clearAffiinityLookupUserEntry,
      clearAffinityLookupAllEntry,
      AffinitySelectAll,
      AffinityShowAll,
      affinityLookupName,
      searchedAffinityName,
      affinityLookupFetch,
      addRewardSearchCriteria,
      isLoadingAffinity,
      selectedProductNames,
      links,
      searchedProductName,
      ProductLookupName,
      isLoadingProduct,
      ProductLookupToggleFlag,
      // ProductLookupFetch,
      selectedProductNamesFnHandler,
      ProductlookupHandler,
      ProductLookupToggleMsg,
      clearProductLookupUserEntry,
      clearProductLookupAllEntry,
      ProductSelectAll,
      ProductShowAll,
      companyLabel,
      affinityLabel,
      userEntry,
      resultWidthValue,
      companies,
      message,
      typing,
      debounce,
      company,
      choosenCompanies,
      andOrSelected,
      chooseCompany,
      removeCompany,
      clickedOut,
      product,
      showCompanyTips,
      products,
      loading,
      choosenProduct,
      chooseProduct,
      removeProduct,
      productLoading,
      tabCloseFlag,
      affinity,
      onResize,
      chooseAffinity,
      affinities,
      sortedMonthYearArray,
      choosenAffinity,
      affinityLoading,
      productClickedOut,
      affinityClickedOut,
      removeAffinity,
      panelistId,
      handleInput,
      panelistFnHandler,
      AndFnHandler,
      OrFnHandler,
      OCRRadio,
      fullTextRadio,
      fromTime,
      drawerFn,
      ToTime,
      leftBarHeight,
      // injectedValue,
      clearAllFlag,
      tofuncManual,
      companyAPICall,
      toggleHandler,
      http,
      masks,
      isAuth,
    };
  },
};
</script>

<style>
/* .scroll-bar::-webkit-scrollbar {
  width: 10px;
} */

.footer-txtcolor {
  color: #999999;
  font-size: 13px;
  border-right: 1px solid #000;
}
span {
  cursor: pointer;
}

.scroll-bar::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 12px;
}

.link {
  cursor: pointer;
  color: blue;
}

.v-navigation-drawer {
  overflow: auto;
  height: 100vh;
  position: fixed;
}
.link:hover {
  color: #0e454d65;
}
.scroll-bar::-webkit-scrollbar-thumb {
  background-color: rgb(185, 185, 185);
  border-radius: 50px;
}

.v-overlay-container > {
  font-size: 5px !important;
}

/* #searchForm__autocomplete {
  min-height: 33px;
  border-bottom: 1px solid #d2d2d2;
  margin-top: 17px;
  display: flex;
  flex-wrap: wrap;
}

#searchForm__autocomplete--text_field {
  outline: none;
}
#searchForm__autocomplete--text_field:focus {
  outline: none;
} */

/* #searchForm__autocomplete--chip {
  background: lightgrey;
  border-radius: 12px;
  padding: 2px 2px 2px 10px;
  margin: 0px 2px 2px 0px;
  height: -webkit-fit-content;
  height: -moz-fit-content;
  height: fit-content;
  font-size: 12px;
  display: flex-inline;
  justify-content: left;
  margin: 0 auto;
  font-weight: 500;
}

#searchForm__list {
  list-style: none;
  margin: 0;
  padding: 0;
  position: absolute;
  z-index: 1;
  width: 230px;
  max-height: 250px;
  overflow-y: scroll;
}

#searchForm__list > li {
  background: #fff;
  border-bottom: 1px solid #d2d2d2;
  padding: 10px;
  cursor: pointer;
  z-index: 1;
} */

/* .v-table.v-table--fixed-header > .v-table__wrapper > table {
  border: 1px solid #0055e3;
} */

.v-table .v-table__wrapper > table > tbody > tr:not(:last-child) > td,
.v-table .v-table__wrapper > table > tbody > tr:not(:last-child) > th {
  border-bottom: thin red;
  border-bottom-style: dotted;
}

.v-table.v-table--fixed-header > .v-table__wrapper > table > thead > tr > th {
  background-color: #3f51b5 !important;
  color: white;
}

.mr10 {
  margin-right: 10px;
}
.datepickerinput {
  border-width: thin !important;
  border-style: solid !important;
  border-color: #a7a6a6;
  width: 130px;
  height: 40px;
  color: #848080;
  border-radius: 4px;
  padding: 11px;
  font-size: initial;
}
.datepickerinput::placeholder {
  color: inherit;
}

@media screen and (min-width: 1366px) and (min-height: 768px) {
  /* Apply styles specific to 2560x1440 resolution */
  /* For example: */
  .v-row .v-row--no-gutters .align-center {
    /* Your styles here */
    font-size: 24px;
    /* Add other styles as needed */
  }
}
@media screen and (min-width: 1920px) and (min-height: 1080px) {
  /* Apply styles specific to 2560x1440 resolution */
  /* For example: */
  .v-row .v-row--no-gutters .align-center {
    /* Your styles here */
    font-size: 28px;
    font-weight: 400;

    /* Add other styles as needed */
  }
  .v-col .v-field__input .v-label .v-input__control .v-field__field {
    font-size: 32px;
  }
  .v-input__control {
    border: 0.8px solid #7a7a7a;
  }
  .v-field-label {
    font-size: 24px;
  }
}
@media screen and (min-width: 2560px) and (min-height: 1440px) {
  /* Apply styles specific to 2560x1440 resolution */
  /* For example: */
  .v-row .v-row--no-gutters .align-center {
    /* Your styles here */
    font-size: 20px;
    /* Add other styles as needed */
  }
}
@media screen and (min-width: 3840px) and (min-height: 2160px) {
  /* Apply styles specific to 2560x1440 resolution */
  /* For example: */
  .v-row .v-row--no-gutters .align-center {
    /* Your styles here */
    font-size: 24px;
    /* Add other styles as needed */
  }
}
@media screen and (min-width: 5120px) and (min-height: 2880px) {
  /* Apply styles specific to 2560x1440 resolution */
  /* For example: */
  .v-row .v-row--no-gutters .align-center {
    /* Your styles here */
    font-size: 34px;
    /* Add other styles as needed */
  }
}
</style>
